/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Button, Form, notification, Steps, Popconfirm } from 'antd';
import Loader from '../../../../components/common/Loader';
import { API_RESPONSE_CODES } from '../../../../utills/constant';
import { fetchLeadDetailsServices } from '../../../auth/slice/authSlice';
import { getBankerService, saveExchangeStep1DraftService, saveExchangeStep2DraftService, saveExchangeStep3DraftService, saveExchangeStep4DraftService,  } from '../../../../services/master-services';
// import ExchangeDetailsWithPRocured from './ExchangeDetailsWithPRocured';
import Step1DetailsSection from './StepsDetails/Step1DetailsSection';
import OTPVerification from './OTPVerification';
import ExchangeStages from './ExchangeStages';
import ExchangeEvaluationDetails from './ExchangeEvaluationDetails';
import Step1VehicleInsuranceForm from './Steps/Step1VehicleInsuranceForm';
import Step2FunctionalBrakeEvaluationForm from './Steps/Step2FunctionalBrakeEvaluationForm';
import Step3MechanicalExteriorForm from './Steps/Step3MechanicalExteriorForm';
import Step4InteriorFinalInspectionForm from './Steps/Step4InteriorFinalInspectionForm';

const { Step } = Steps;

const ExchangeEvaluationMultiStep = () => {
  const { id } = useParams();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [bankerList, setBankerList] = useState([]);
  const [showDetailsPage, setShowDetailsPage] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [isOTPVerified, setIsOTPVerified] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [pendingStep, setPendingStep] = useState(null);
  const [showExchangeDetails, setShowExchangeDetails] = useState(false);
  const leadViewDetails = useSelector((state) => state?.auth?.leadDetails);
  const roleType = useSelector((state) => state?.auth?.userData?.role);
  
  // Handle navigation based on current_form_step
  useEffect(() => {
    const currentFormStep = leadViewDetails?.exchange_vehicle_detail?.current_form_step;
    
    // Check if "Pre evaluation" stage (stage id 2) is completed
    const preEvaluationStage = leadViewDetails?.exchange_stage_history?.find(stage => 
      stage.lead_exchange_stage_id === 2 && stage.status === 2
    );
    
    // Check for Procurement Manager condition - Quality Inspection not started yet (Pre evaluation in progress)
    const preEvaluationInProgress = leadViewDetails?.exchange_stage_history?.filter(stage => 
      (stage.lead_exchange_stage_id === 2 && stage.status === 1)
    ).length > 0;
    
    const qualityInspectionNotStarted = leadViewDetails?.exchange_stage_history?.filter(stage => 
      (stage.lead_exchange_stage_id === 3 && stage.status === 1)
    ).length > 0;
    
    const procurementManagerStage = preEvaluationInProgress || qualityInspectionNotStarted;
    
    // Check if "pending for evaluation" stage is in progress (stage id 1)
    const pendingForEvaluationInProgress = leadViewDetails?.exchange_stage_history?.filter(stage => 
      (stage.lead_exchange_stage_id === 1 && stage.status === 1)
    ).length > 0;
    
    // Check for Procurement Manager after reject (stage 4 in progress)
    const procurementManagerRejectStage = leadViewDetails?.exchange_stage_history?.filter(stage => 
      (stage.lead_exchange_stage_id === 4 && stage.status === 1)
    );
    
    // Check for Exchange Evaluation Team re-evaluation condition
    const reEvaluationStage = leadViewDetails?.exchange_stage_history?.filter(stage => 
      (stage.lead_exchange_stage_id === 4 && stage.status === 1)
    );

    // Check for Pre Final Assessment in progress (stage 6)
    const preFinalAssessmentStage = leadViewDetails?.exchange_stage_history?.filter(stage =>
      (stage.lead_exchange_stage_id === 6 && stage.status === 1)
    );

    // Check for Final Assessment in progress (stage 7)
    const finalAssessmentStage = leadViewDetails?.exchange_stage_history?.filter(stage =>
      (stage.lead_exchange_stage_id === 7 && stage.status === 1)
    );

    // Priority 1: If Procurement Manager with Pre evaluation in progress and Quality Inspection not started, show forms with default values
    if ((roleType === 'Procurement Manager' || roleType === 'Super Admin') && procurementManagerStage) {
      
      setCurrentStep(0); // Start from Step 1
      setIsOTPVerified(true); // Skip OTP verification
      setShowDetailsPage(false); // Ensure details page is not shown
      setShowLoader(true); // Show loader instead of OTP screen
      
      // Hide loader after 2 seconds and show the form
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
      return;
    }
    
    // Priority 1.5: If Pre evaluation is in progress, skip OTP verification
    if (preEvaluationInProgress) {
      setCurrentStep(0); // Start from Step 1
      setIsOTPVerified(true); // Skip OTP verification
      setShowDetailsPage(false); // Ensure details page is not shown
      setShowLoader(true); // Show loader instead of OTP screen
      
      // Hide loader after 2 seconds and show the form
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
      return;
    }
    
    // Priority 2: If Procurement Manager after reject (stage 4 status 1), show forms with default values
    if ((roleType === 'Procurement Manager' || roleType === 'Super Admin') && procurementManagerRejectStage?.length > 0) {
      setCurrentStep(0); // Start from Step 1
      setIsOTPVerified(true); // Skip OTP verification
      setShowDetailsPage(false); // Ensure details page is not shown
      setShowLoader(true); // Show loader instead of OTP screen
      
      // Hide loader after 2 seconds and show the form
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
      return;
    }
    
    // Priority 3: If either role with Re Evaluation stage 4 status 1 (Start Re-evaluation button clicked), show forms with default values
    if ((roleType === 'Procurement Manager' || roleType === 'Exchange Evaluation Team' || roleType === 'Super Admin') && reEvaluationStage?.length > 0) {
      setCurrentStep(0); // Start from Step 1
      setIsOTPVerified(true); // Skip OTP verification
      setShowDetailsPage(false); // Ensure details page is not shown
      setShowLoader(true); // Show loader instead of OTP screen
      
      // Hide loader after 2 seconds and show the form
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
      return;
    }

    // Priority 3b: If either role with Pre Final Assessment (stage 6) in progress, start forms with default values
    if ((roleType === 'Procurement Manager' || roleType === 'Exchange Evaluation Team' || roleType === 'Super Admin') && preFinalAssessmentStage?.length > 0) {
      setCurrentStep(0); // Start from Step 1
      setIsOTPVerified(true); // Skip OTP verification
      setShowDetailsPage(false); // Ensure details page is not shown
      setShowLoader(true); // Show loader instead of OTP screen
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
      return;
    }

    // Priority 3c: If Final Assessment (stage 7) in progress, only Procurement Manager can start
    if ((roleType === 'Procurement Manager' || roleType === 'Super Admin') && finalAssessmentStage?.length > 0) {
      setCurrentStep(0);
      setIsOTPVerified(true);
      setShowDetailsPage(false);
      setShowLoader(true);
      setTimeout(() => {
        setShowLoader(false);
      }, 2000);
      return;
    }
    
    // Priority 4: If Pre evaluation stage is completed, show details page
    if (preEvaluationStage) {
      setShowDetailsPage(true);
      return;
    }
    
    // Only show OTP verification if "pending for evaluation" stage is in progress
    if (pendingForEvaluationInProgress) {
      setCurrentStep(0); // Start from Step 1
      setIsOTPVerified(false); // Show OTP verification
      setShowDetailsPage(false); // Ensure details page is not shown
      setShowLoader(false); // Don't show loader
      return;
    }
    
    if (currentFormStep !== null && currentFormStep !== undefined) {
      if (currentFormStep === 1) {
        setCurrentStep(1); // Navigate to step 2
        setIsOTPVerified(true); // Skip OTP verification
      } else if (currentFormStep === 2) {
        setCurrentStep(2); // Navigate to step 3
        setIsOTPVerified(true); // Skip OTP verification
      } else if (currentFormStep === 3) {
        setCurrentStep(3); // Navigate to step 4
        setIsOTPVerified(true); // Skip OTP verification
      } else if (currentFormStep === 4) {
        setCurrentStep(3); // Stay on step 4 (last step)
        setIsOTPVerified(true); // Skip OTP verification
      }
      // If currentFormStep is null, keep default behavior (step 0, OTP required)
    }
  }, [leadViewDetails]);
  
  const [fileList, setFileList] = useState({
    copy_of_front_rc: [],
    copy_of_back_rc: [],
    back_image: [],
    side_image: [],
    front_image: [],
    bank_statement: [],
    copy_of_insurance: [],
    transfer_document: [],
    copy_of_customer_agreement: [],
    city_registrations_document: [],
    accessories_repairs_document: [],
    exterior_front: [],
    exterior_left: [],
    exterior_right: [],
    exterior_back: [],
    interior_front: [],
    interior_back: [],
    bonnet_open: [],
    boot_open: [],
    odometer_document: [],
    vin_plate_document: [],
    engine_number_document: [],
    insurance_document: [],
    city_registrations_document_file: [],
    // Step 2 file fields
    engine_oil_leakage_file: [],
    coolant_leakage_file: [],
    radiator_damage_file: [],
    starter_motor_defect_file: [],
    engine_noise_file: [],
    low_pickup_file: [],
    engine_smoke_file: [],
    defective_belts_file: [],
    engine_replaced_endorsed_file: [],
    rough_engine_file: [],
    engine_rpm_defect_file: [],
    brake_disk_damage_file: [],
    brake_defect_file: [],
    abs_ebd_defect_file: [],
    keyless_cylinder_defect_file: [],
    warning_lamp_defect_file: [],
    infotainment_system_defect_file: [],
    fog_lamp_defect_file: [],
    horn_defect_file: [],
    wiper_defect_file: [],
    navigation_system_defect_file: [],
    analog_music_system_defect_file: [],
    cruise_control_defect_file: [],
    steering_wheel_control_defect_file: [],
    // Step 3 file fields
    clutch_defect_file: [],
    transmission_oil_leak_file: [],
    shift_shock_time_lag_file: [],
    drive_shaft_defect_file: [],
    wheel_noise_defect_file: [],
    modified_suspension_file: [],
    steering_noise_file: [],
    steering_oil_leak_file: [],
    steering_shaft_boot_cut_file: [],
    jammed_steering_file: [],
    defective_telescopic_tilt_file: [],
    rh_rocker_panel_file: [],
    lh_rocker_panel_file: [],
    rh_rear_fender_panel_file: [],
    lh_rear_fender_panel_file: [],
    end_panel_file: [],
    front_tyre_left_file: [],
    front_tyre_right_file: [],
    back_tyre_left_file: [],
    back_tyre_right_file: [],
    exterior_front_paint_file: [],
    exterior_left_paint_file: [],
    exterior_right_paint_file: [],
    exterior_rear_paint_file: [],
    exterior_top_paint_file: [],
    // accessories_repairs_document: [],
  });


  const [fileList1, setFileList1] = useState({
    bank_statement: [],
    transfer_document: [],
  });

  const [fileList3, setFileList3] = useState({
    // Step 3 file fields
    clutch_defect_file: [],
    transmission_oil_leak_file: [],
    shift_shock_time_lag_file: [],
    gearbox_defect_file: [],
    drive_shaft_defect_file: [],
    boot_cut_file: [],
    differential_noise_file: [],
    wheel_noise_defect_file: [],
    modified_suspension_file: [],
    steering_noise_file: [],
    steering_oil_leak_file: [],
    steering_shaft_boot_cut_file: [],
    jammed_steering_file: [],
    defective_telescopic_tilt_file: [],
    rh_rocker_panel_file: [],
    lh_rocker_panel_file: [],
    rh_rear_fender_panel_file: [],
    lh_rear_fender_panel_file: [],
    end_panel_file: [],
    jack_tools_kit_file: [],
    door_lock_defect_file: [],
    periodic_service_file: [],
    carpet_upholstery_file: [],
    spare_keys_file: [],
    legal_case_resolution_file: [],
    original_accessories_file: [],
    front_tyre_left_file: [],
    front_tyre_right_file: [],
    back_tyre_left_file: [],
    back_tyre_right_file: [],
    spare_wheels_file: [],
    front_spoiler_file: [],
    front_bumper_file: [],
    grill_file: [],
    rear_bumper_file: [],
    rear_spoiler_file: [],
    head_light_file: [],
    tail_light_file: [],
    fog_lamp_file: [],
    side_mirror_file: [],
    mud_flap_file: [],
    windshield_glass_file: [],
    wheel_cover_file: [],
    weather_strip_file: [],
    logo_missing_file: [],
    exterior_front_paint_file: [],
    exterior_left_paint_file: [],
    exterior_right_paint_file: [],
    exterior_rear_paint_file: [],
    exterior_top_paint_file: [],
  });

  const [fileList4, setFileList4] = useState({
    // Step 4 file fields - Vehicle Performance and Safety
    abnormal_noise_file: [],
    pedal_handling_defect_file: [],
    alignment_file: [],
    shock_absorber_defect_file: [],
    seat_belt_lock_file: [],
    
    // Body Panel Replacements
    replaced_front_door_panel_file: [],
    replaced_rear_door_panel_file: [],
    replaced_front_fender_panel_file: [],
    replaced_bonnet_hood_panel_file: [],
    replaced_trunk_hood_panel_file: [],
    
    // Structural Components
    front_cross_member_file: [],
    upper_core_support_file: [],
    core_support_file: [],
    rear_wheel_house_file: [],
    front_side_member_file: [],
    front_inside_panel_file: [],
    front_pillar_file: [],
    center_pillar_file: [],
    roof_panel_file: [],
    dash_panel_file: [],
    floor_cross_member_file: [],
    floor_side_member_file: [],
    center_floor_panel_file: [],
    rear_side_member_file: [],
    rear_floor_panel_file: [],
    rear_inside_panel_file: [],
    rear_cross_member_file: [],
    
    // Seating
    driver_seat_file: [],
    co_driver_seat_file: [],
    rear_seats_file: [],
    
    // Interior Features
    sunroof_file: [],
    wireless_charger_file: [],
    cup_holders_file: [],
    glove_box_file: [],
    front_ac_file: [],
    rear_ac_file: [],
    front_floor_mat_file: [],
    rear_floor_mat_file: [],
    seat_belts_front_file: [],
    seat_belts_rear_file: [],
    door_handles_front_file: [],
    door_handles_rear_file: [],
    
    // Interior Cleaning
    interior_cleaning_file: [],
    
    // Additional Step 4 fields
    drive_mode_faulty_file: [],
    lane_assist_defect_file: [],
    hill_assist_defect_file: [],
  });

  const dateFormat = 'DD/MM/YYYY';
  const [total, setTotal] = useState(leadViewDetails?.exchange_vehicle_detail?.total_refurishment_cost);
  const steps = [
    {
      title: 'Vehicle & Insurance Details',
      content: 'First-content',
    },
    {
      title: 'Functional & Brake Evaluation',
      content: 'Second-content',
    },
    {
      title: 'Mechanical & Exterior Details',
      content: 'Third-content',
    },
    {
      title: 'Interior & Final Inspection',
      content: 'Fourth-content',
    },
  ];

  // Function to determine which steps are clickable
  const getClickableSteps = () => {
    const currentFormStep = leadViewDetails?.exchange_vehicle_detail?.current_form_step;
    
    // Check if Pre Evaluation is completed (stage 2 with status 2)
    const isPreEvaluationCompleted = leadViewDetails?.exchange_stage_history?.filter(stage => 
      (stage.lead_exchange_stage_id === 2 && stage.status === 2)
    ).length > 0;
    
    // If Pre Evaluation is completed, all steps are clickable
    if (isOTPVerified && isPreEvaluationCompleted) {
      return { maxClickableStep: 3, isPreEvaluationCompleted: true };
    }
    
    // If OTP is verified, check step accessibility based on current_form_step
    if (isOTPVerified) {
      let maxClickableStep = -1; // Default: no steps clickable
      
      if (currentFormStep !== null && currentFormStep !== undefined) {
        // Map current_form_step (1,2,3,4) to step indices (0,1,2,3)
        // If current_form_step is 1, then step 0 is clickable
        // If current_form_step is 2, then steps 0,1 are clickable
        // If current_form_step is 3, then steps 0,1,2 are clickable
        // If current_form_step is 4, then steps 0,1,2,3 are clickable
        maxClickableStep = currentFormStep - 1;
      }
      
      return { maxClickableStep, isPreEvaluationCompleted: false };
    }
    
    // If OTP is not verified, only step 0 is clickable
    return { maxClickableStep: 0, isPreEvaluationCompleted: false };
  };

  // Handle step navigation
  const handleStepChange = (step) => {
    const { maxClickableStep, isPreEvaluationCompleted } = getClickableSteps();
    
    // If Pre Evaluation is completed, allow navigation to any step
    if (isOTPVerified && isPreEvaluationCompleted) {
      setCurrentStep(step);
      return;
    }
    
    // Allow navigation only to steps that are clickable
    if (step <= maxClickableStep) {
      setCurrentStep(step);
    } else {
      // Set pending step for Popconfirm
      setPendingStep(step);
    }
  };


  // Handle step navigation cancellation
  const handleStepCancel = () => {
    setPendingStep(null);
  };

  const setUploadComponentData = (imagesData) => {
    const formattedFileLists = {
      front_image: [],
      back_image: [],
      side_image: [],
      copy_of_front_rc: [],
      copy_of_back_rc: [],
      copy_of_insurance: [],
      copy_of_customer_agreement: [],
      city_registrations_document: [],
      accessories_repairs_document: [],
      exterior_front: [],
      exterior_left: [],
      exterior_right: [],
      exterior_back: [],
      interior_front: [],
      interior_back: [],
      bonnet_open: [],
      boot_open: [],
      odometer_document: [],
      vin_plate_document: [],
      engine_number_document: [],
      insurance_document: [],
      city_registrations_document_file: [],
      // Step 2 file fields
      engine_oil_leakage_file: [],
      coolant_leakage_file: [],
      radiator_damage_file: [],
      starter_motor_defect_file: [],
      engine_noise_file: [],
      low_pickup_file: [],
      engine_smoke_file: [],
      defective_belts_file: [],
      engine_replaced_endorsed_file: [],
      rough_engine_file: [],
      engine_rpm_defect_file: [],
      brake_disk_damage_file: [],
      brake_defect_file: [],
      abs_ebd_defect_file: [],
      keyless_cylinder_defect_file: [],
      warning_lamp_defect_file: [],
      infotainment_system_defect_file: [],
      fog_lamp_defect_file: [],
      horn_defect_file: [],
      wiper_defect_file: [],
      navigation_system_defect_file: [],
      analog_music_system_defect_file: [],
      cruise_control_defect_file: [],
      steering_wheel_control_defect_file: [],
      // Step 3 file fields
      clutch_defect_file: [],
      transmission_oil_leak_file: [],
      shift_shock_time_lag_file: [],
      drive_shaft_defect_file: [],
      wheel_noise_defect_file: [],
      modified_suspension_file: [],
      steering_noise_file: [],
      steering_oil_leak_file: [],
      steering_shaft_boot_cut_file: [],
      jammed_steering_file: [],
      defective_telescopic_tilt_file: [],
      rh_rocker_panel_file: [],
      lh_rocker_panel_file: [],
      rh_rear_fender_panel_file: [],
      lh_rear_fender_panel_file: [],
      end_panel_file: [],
      front_tyre_left_file: [],
      front_tyre_right_file: [],
      back_tyre_left_file: [],
      back_tyre_right_file: [],
      exterior_front_paint_file: [],
      exterior_left_paint_file: [],
      exterior_right_paint_file: [],
      exterior_rear_paint_file: [],
      exterior_top_paint_file: [],
      // Additional Step 3 file fields
      gearbox_defect_file: [],
      boot_cut_file: [],
      differential_noise_file: [],
      jack_tools_kit_file: [],
      door_lock_defect_file: [],
      periodic_service_file: [],
      carpet_upholstery_file: [],
      spare_keys_file: [],
      legal_case_resolution_file: [],
      original_accessories_file: [],
      spare_wheels_file: [],
      front_spoiler_file: [],
      front_bumper_file: [],
      grill_file: [],
      rear_bumper_file: [],
      rear_spoiler_file: [],
      head_light_file: [],
      tail_light_file: [],
      fog_lamp_file: [],
      side_mirror_file: [],
      mud_flap_file: [],
      windshield_glass_file: [],
      wheel_cover_file: [],
      weather_strip_file: [],
      logo_missing_file: [],
      // Step 4 file fields
      abnormal_noise_file: [],
      pedal_handling_defect_file: [],
      alignment_file: [],
      shock_absorber_defect_file: [],
      seat_belt_lock_file: [],
      replaced_front_door_panel_file: [],
      replaced_rear_door_panel_file: [],
      replaced_front_fender_panel_file: [],
      replaced_bonnet_hood_panel_file: [],
      replaced_trunk_hood_panel_file: [],
      front_cross_member_file: [],
      upper_core_support_file: [],
      core_support_file: [],
      rear_wheel_house_file: [],
      front_side_member_file: [],
      front_inside_panel_file: [],
      front_pillar_file: [],
      center_pillar_file: [],
      roof_panel_file: [],
      dash_panel_file: [],
      floor_cross_member_file: [],
      floor_side_member_file: [],
      center_floor_panel_file: [],
      rear_side_member_file: [],
      rear_floor_panel_file: [],
      rear_inside_panel_file: [],
      rear_cross_member_file: [],
      driver_seat_file: [],
      co_driver_seat_file: [],
      rear_seats_file: [],
      sunroof_file: [],
      wireless_charger_file: [],
      cup_holders_file: [],
      glove_box_file: [],
      front_ac_file: [],
      rear_ac_file: [],
      front_floor_mat_file: [],
      rear_floor_mat_file: [],
      seat_belts_front_file: [],
      seat_belts_rear_file: [],
      door_handles_front_file: [],
      door_handles_rear_file: [],
      interior_cleaning_file: [],
      drive_mode_faulty_file: [],
      lane_assist_defect_file: [],
      hill_assist_defect_file: [],
    };

    imagesData?.forEach((doc) => {
      const file = {
        uid: doc.id,
        name: doc.document_file_name,
        status: 'done',
        url: doc.document_path,
      };

      switch (doc.document_type) {
        case 'Front':
          formattedFileLists.front_image.push(file);
          break;
        case 'Back':
          formattedFileLists.back_image.push(file);
          break;
        case 'Side':
          formattedFileLists.side_image.push(file);
          break;
        case 'Transfer':
          formattedFileLists.transfer_document.push(file);
          break;
        case 'Bank Statement':
          formattedFileLists?.bank_statement?.push(file);
          break;
        case 'RC':
        case 'Exchange Front RC':
        case 'EXCHANGE_FRONT_RC':
          formattedFileLists.copy_of_front_rc.push(file);
          break;
        case 'Exchange Back RC':
        case 'EXCHANGE_BACK_RC':
          formattedFileLists.copy_of_back_rc.push(file);
          break;
        case 'Customer Agreement':
          formattedFileLists.copy_of_customer_agreement.push(file);
          break;
        case 'Odometer Reading':
          formattedFileLists.odometer_document.push(file);
          break;
        case 'Engine Number':
          formattedFileLists.engine_number_document.push(file);
          break;
        case 'Vin Plate':
          formattedFileLists.vin_plate_document.push(file);
          break;
        case 'Insurance Policy':
          formattedFileLists.insurance_document.push(file);
          break;
        case 'City Registration':
          formattedFileLists.city_registrations_document_file.push(file);
          break;
        case 'City Registrations Document':
          formattedFileLists.city_registrations_document_file.push(file);
          break;
        case 'Accessories Repairs':
          formattedFileLists.accessories_repairs_document.push(file);
          break;
        case 'Exterior Front':
          formattedFileLists.exterior_front.push(file);
          break;
        case 'Exterior Back':
          formattedFileLists.exterior_back.push(file);
          break;
        case 'Exterior Left':
          formattedFileLists.exterior_left.push(file);
          break;
        case 'Exterior Right':
          formattedFileLists.exterior_right.push(file);
          break;
        case 'Interior Front':
          formattedFileLists.interior_front.push(file);
          break;
        case 'Interior Back':
          formattedFileLists.interior_back.push(file);
          break;
        case 'Bonnet Open':
          formattedFileLists.bonnet_open.push(file);
          break;
        case 'Boot Open':
          formattedFileLists.boot_open.push(file);
          break;
        case 'Engine Oil Leakage':
          formattedFileLists.engine_oil_leakage_file = formattedFileLists.engine_oil_leakage_file || [];
          formattedFileLists.engine_oil_leakage_file.push(file);
          break;
        case 'Coolant Leakage':
          formattedFileLists.coolant_leakage_file = formattedFileLists.coolant_leakage_file || [];
          formattedFileLists.coolant_leakage_file.push(file);
          break;
        case 'Radiator Damage':
          formattedFileLists.radiator_damage_file = formattedFileLists.radiator_damage_file || [];
          formattedFileLists.radiator_damage_file.push(file);
          break;
        case 'Starter Motor Defect':
          formattedFileLists.starter_motor_defect_file = formattedFileLists.starter_motor_defect_file || [];
          formattedFileLists.starter_motor_defect_file.push(file);
          break;
        case 'Engine Noise':
          formattedFileLists.engine_noise_file = formattedFileLists.engine_noise_file || [];
          formattedFileLists.engine_noise_file.push(file);
          break;
        case 'Low Pickup':
          formattedFileLists.low_pickup_file = formattedFileLists.low_pickup_file || [];
          formattedFileLists.low_pickup_file.push(file);
          break;
        case 'Engine Smoke':
          formattedFileLists.engine_smoke_file = formattedFileLists.engine_smoke_file || [];
          formattedFileLists.engine_smoke_file.push(file);
          break;
        case 'Defective Belts':
          formattedFileLists.defective_belts_file = formattedFileLists.defective_belts_file || [];
          formattedFileLists.defective_belts_file.push(file);
          break;
        case 'Engine Replaced Endorsed':
          formattedFileLists.engine_replaced_endorsed_file = formattedFileLists.engine_replaced_endorsed_file || [];
          formattedFileLists.engine_replaced_endorsed_file.push(file);
          break;
        case 'Rough Engine':
          formattedFileLists.rough_engine_file = formattedFileLists.rough_engine_file || [];
          formattedFileLists.rough_engine_file.push(file);
          break;
        case 'Engine RPM Defect':
          formattedFileLists.engine_rpm_defect_file = formattedFileLists.engine_rpm_defect_file || [];
          formattedFileLists.engine_rpm_defect_file.push(file);
          break;
        case 'Brake Disk Damage':
          formattedFileLists.brake_disk_damage_file = formattedFileLists.brake_disk_damage_file || [];
          formattedFileLists.brake_disk_damage_file.push(file);
          break;
        case 'Brake Defect':
          formattedFileLists.brake_defect_file = formattedFileLists.brake_defect_file || [];
          formattedFileLists.brake_defect_file.push(file);
          break;
        case 'ABS EBD Defect':
          formattedFileLists.abs_ebd_defect_file = formattedFileLists.abs_ebd_defect_file || [];
          formattedFileLists.abs_ebd_defect_file.push(file);
          break;
        case 'Keyless Cylinder Defect':
          formattedFileLists.keyless_cylinder_defect_file = formattedFileLists.keyless_cylinder_defect_file || [];
          formattedFileLists.keyless_cylinder_defect_file.push(file);
          break;
        case 'Warning Lamp Defect':
          formattedFileLists.warning_lamp_defect_file = formattedFileLists.warning_lamp_defect_file || [];
          formattedFileLists.warning_lamp_defect_file.push(file);
          break;
        case 'Infotainment System Defect':
          formattedFileLists.infotainment_system_defect_file = formattedFileLists.infotainment_system_defect_file || [];
          formattedFileLists.infotainment_system_defect_file.push(file);
          break;
        case 'Head Lamp Defect':
          formattedFileLists.head_lamp_defect_file = formattedFileLists.head_lamp_defect_file || [];
          formattedFileLists.head_lamp_defect_file.push(file);
          break;
        case 'Headlamp Defect':
          formattedFileLists.head_lamp_defect_file = formattedFileLists.head_lamp_defect_file || [];
          formattedFileLists.head_lamp_defect_file.push(file);
          break;
        case 'Fog Lamp Defect':
          formattedFileLists.fog_lamp_defect_file = formattedFileLists.fog_lamp_defect_file || [];
          formattedFileLists.fog_lamp_defect_file.push(file);
          break;
        case 'Horn Defect':
          formattedFileLists.horn_defect_file = formattedFileLists.horn_defect_file || [];
          formattedFileLists.horn_defect_file.push(file);
          break;
        case 'Wiper Defect':
          formattedFileLists.wiper_defect_file = formattedFileLists.wiper_defect_file || [];
          formattedFileLists.wiper_defect_file.push(file);
          break;
        case 'Navigation System Defect':
          formattedFileLists.navigation_system_defect_file = formattedFileLists.navigation_system_defect_file || [];
          formattedFileLists.navigation_system_defect_file.push(file);
          break;
        case 'Analog Music System Defect':
          formattedFileLists.analog_music_system_defect_file = formattedFileLists.analog_music_system_defect_file || [];
          formattedFileLists.analog_music_system_defect_file.push(file);
          break;
        case 'Cruise Control Defect':
          formattedFileLists.cruise_control_defect_file = formattedFileLists.cruise_control_defect_file || [];
          formattedFileLists.cruise_control_defect_file.push(file);
          break;
        case 'Steering Wheel Control Defect':
          formattedFileLists.steering_wheel_control_defect_file = formattedFileLists.steering_wheel_control_defect_file || [];
          formattedFileLists.steering_wheel_control_defect_file.push(file);
          break;
        case 'Electronic Mirror Defect':
          formattedFileLists.electronic_mirror_defect_file = formattedFileLists.electronic_mirror_defect_file || [];
          formattedFileLists.electronic_mirror_defect_file.push(file);
          break;
        case 'Battery Defect':
          formattedFileLists.battery_defect_file = formattedFileLists.battery_defect_file || [];
          formattedFileLists.battery_defect_file.push(file);
          break;
        case 'Music System Defect':
          formattedFileLists.music_system_defect_file = formattedFileLists.music_system_defect_file || [];
          formattedFileLists.music_system_defect_file.push(file);
          break;
        case 'Power Window Defect':
          formattedFileLists.power_window_defect_file = formattedFileLists.power_window_defect_file || [];
          formattedFileLists.power_window_defect_file.push(file);
          break;
        case 'Auto Headlight Wiper Defect':
          formattedFileLists.auto_headlight_wiper_defect_file = formattedFileLists.auto_headlight_wiper_defect_file || [];
          formattedFileLists.auto_headlight_wiper_defect_file.push(file);
          break;
        case 'Electronic Tailgate Defect':
          formattedFileLists.electronic_tailgate_defect_file = formattedFileLists.electronic_tailgate_defect_file || [];
          formattedFileLists.electronic_tailgate_defect_file.push(file);
          break;
        case 'Parking Sensor Defect':
          formattedFileLists.parking_sensor_defect_file = formattedFileLists.parking_sensor_defect_file || [];
          formattedFileLists.parking_sensor_defect_file.push(file);
          break;
        case 'AC Defective':
          formattedFileLists.ac_defective_file = formattedFileLists.ac_defective_file || [];
          formattedFileLists.ac_defective_file.push(file);
          break;
        case 'Roof AC':
          formattedFileLists.roof_ac_file = formattedFileLists.roof_ac_file || [];
          formattedFileLists.roof_ac_file.push(file);
          break;
        case 'Roof AC Defect':
          formattedFileLists.roof_ac_file = formattedFileLists.roof_ac_file || [];
          formattedFileLists.roof_ac_file.push(file);
          break;
        case 'Ventilated Seat Defect':
          formattedFileLists.ventilated_seat_defect_file = formattedFileLists.ventilated_seat_defect_file || [];
          formattedFileLists.ventilated_seat_defect_file.push(file);
          break;
        case 'Electronic Seat Defect':
          formattedFileLists.electronic_seat_defect_file = formattedFileLists.electronic_seat_defect_file || [];
          formattedFileLists.electronic_seat_defect_file.push(file);
          break;
        case 'Paddle Shift Defect':
          formattedFileLists.paddle_shift_defect_file = formattedFileLists.paddle_shift_defect_file || [];
          formattedFileLists.paddle_shift_defect_file.push(file);
          break;
        case 'Tyre Pressuring Monitoring System Defect':
          formattedFileLists.tyre_pressuring_monitoring_system_defect_file = formattedFileLists.tyre_pressuring_monitoring_system_defect_file || [];
          formattedFileLists.tyre_pressuring_monitoring_system_defect_file.push(file);
          break;
        case 'Sun Roof Defect':
          formattedFileLists.sun_roof_defect_file = formattedFileLists.sun_roof_defect_file || [];
          formattedFileLists.sun_roof_defect_file.push(file);
          break;
        case 'Rear View Mirror IRVM':
          formattedFileLists.rear_view_mirror_irvm_file = formattedFileLists.rear_view_mirror_irvm_file || [];
          formattedFileLists.rear_view_mirror_irvm_file.push(file);
          break;
        case 'Rear View Mirror ORVM':
          formattedFileLists.rear_view_mirror_orvm_file = formattedFileLists.rear_view_mirror_orvm_file || [];
          formattedFileLists.rear_view_mirror_orvm_file.push(file);
          break;
        // Step 3 - Mechanical & Exterior Details file mappings
        case 'Clutch Defect':
          formattedFileLists.clutch_defect_file = formattedFileLists.clutch_defect_file || [];
          formattedFileLists.clutch_defect_file.push(file);
          break;
        case 'Transmission Oil Leak':
          formattedFileLists.transmission_oil_leak_file = formattedFileLists.transmission_oil_leak_file || [];
          formattedFileLists.transmission_oil_leak_file.push(file);
          break;
        case 'Shift Shock Time Lag':
          formattedFileLists.shift_shock_time_lag_file = formattedFileLists.shift_shock_time_lag_file || [];
          formattedFileLists.shift_shock_time_lag_file.push(file);
          break;
        case 'Drive Shaft Defect':
          formattedFileLists.drive_shaft_defect_file = formattedFileLists.drive_shaft_defect_file || [];
          formattedFileLists.drive_shaft_defect_file.push(file);
          break;
        case 'Wheel Noise Defect':
          formattedFileLists.wheel_noise_defect_file = formattedFileLists.wheel_noise_defect_file || [];
          formattedFileLists.wheel_noise_defect_file.push(file);
          break;
        case 'Modified Suspension':
          formattedFileLists.modified_suspension_file = formattedFileLists.modified_suspension_file || [];
          formattedFileLists.modified_suspension_file.push(file);
          break;
        case 'Steering Noise':
          formattedFileLists.steering_noise_file = formattedFileLists.steering_noise_file || [];
          formattedFileLists.steering_noise_file.push(file);
          break;
        case 'Steering Oil Leak':
          formattedFileLists.steering_oil_leak_file = formattedFileLists.steering_oil_leak_file || [];
          formattedFileLists.steering_oil_leak_file.push(file);
          break;
        case 'Steering Shaft Boot Cut':
          formattedFileLists.steering_shaft_boot_cut_file = formattedFileLists.steering_shaft_boot_cut_file || [];
          formattedFileLists.steering_shaft_boot_cut_file.push(file);
          break;
        case 'Jammed Steering':
          formattedFileLists.jammed_steering_file = formattedFileLists.jammed_steering_file || [];
          formattedFileLists.jammed_steering_file.push(file);
          break;
        case 'Defective Telescopic Tilt':
          formattedFileLists.defective_telescopic_tilt_file = formattedFileLists.defective_telescopic_tilt_file || [];
          formattedFileLists.defective_telescopic_tilt_file.push(file);
          break;
        case 'RH Rocker Panel':
          formattedFileLists.rh_rocker_panel_file = formattedFileLists.rh_rocker_panel_file || [];
          formattedFileLists.rh_rocker_panel_file.push(file);
          break;
        case 'LH Rocker Panel':
          formattedFileLists.lh_rocker_panel_file = formattedFileLists.lh_rocker_panel_file || [];
          formattedFileLists.lh_rocker_panel_file.push(file);
          break;
        case 'RH Rear Fender Panel':
          formattedFileLists.rh_rear_fender_panel_file = formattedFileLists.rh_rear_fender_panel_file || [];
          formattedFileLists.rh_rear_fender_panel_file.push(file);
          break;
        case 'LH Rear Fender Panel':
          formattedFileLists.lh_rear_fender_panel_file = formattedFileLists.lh_rear_fender_panel_file || [];
          formattedFileLists.lh_rear_fender_panel_file.push(file);
          break;
        case 'End Panel':
          formattedFileLists.end_panel_file = formattedFileLists.end_panel_file || [];
          formattedFileLists.end_panel_file.push(file);
          break;
        case 'Front Tyre Left':
          formattedFileLists.front_tyre_left_file = formattedFileLists.front_tyre_left_file || [];
          formattedFileLists.front_tyre_left_file.push(file);
          break;
        case 'Front Tyre Right':
          formattedFileLists.front_tyre_right_file = formattedFileLists.front_tyre_right_file || [];
          formattedFileLists.front_tyre_right_file.push(file);
          break;
        case 'Back Tyre Left':
          formattedFileLists.back_tyre_left_file = formattedFileLists.back_tyre_left_file || [];
          formattedFileLists.back_tyre_left_file.push(file);
          break;
        case 'Back Tyre Right':
          formattedFileLists.back_tyre_right_file = formattedFileLists.back_tyre_right_file || [];
          formattedFileLists.back_tyre_right_file.push(file);
          break;
        case 'Exterior Front Paint':
          formattedFileLists.exterior_front_paint_file = formattedFileLists.exterior_front_paint_file || [];
          formattedFileLists.exterior_front_paint_file.push(file);
          break;
        case 'Exterior Left Paint':
          formattedFileLists.exterior_left_paint_file = formattedFileLists.exterior_left_paint_file || [];
          formattedFileLists.exterior_left_paint_file.push(file);
          break;
        case 'Exterior Right Paint':
          formattedFileLists.exterior_right_paint_file = formattedFileLists.exterior_right_paint_file || [];
          formattedFileLists.exterior_right_paint_file.push(file);
          break;
        case 'Exterior Right paint':
          formattedFileLists.exterior_right_paint_file = formattedFileLists.exterior_right_paint_file || [];
          formattedFileLists.exterior_right_paint_file.push(file);
          break;
        case 'Exterior Rear Paint':
          formattedFileLists.exterior_rear_paint_file = formattedFileLists.exterior_rear_paint_file || [];
          formattedFileLists.exterior_rear_paint_file.push(file);
          break;
        case 'Exterior Rear paint':
          formattedFileLists.exterior_rear_paint_file = formattedFileLists.exterior_rear_paint_file || [];
          formattedFileLists.exterior_rear_paint_file.push(file);
          break;
        case 'Exterior Top Paint':
          formattedFileLists.exterior_top_paint_file = formattedFileLists.exterior_top_paint_file || [];
          formattedFileLists.exterior_top_paint_file.push(file);
          break;
        // Additional Step 3 mappings that might be missing
        case 'GearBox Defect':
          formattedFileLists.gearbox_defect_file = formattedFileLists.gearbox_defect_file || [];
          formattedFileLists.gearbox_defect_file.push(file);
          break;
        case 'Boot Cut':
          formattedFileLists.boot_cut_file = formattedFileLists.boot_cut_file || [];
          formattedFileLists.boot_cut_file.push(file);
          break;
        case 'Differential Noise':
          formattedFileLists.differential_noise_file = formattedFileLists.differential_noise_file || [];
          formattedFileLists.differential_noise_file.push(file);
          break;
        case 'Jack Tools Kit':
          formattedFileLists.jack_tools_kit_file = formattedFileLists.jack_tools_kit_file || [];
          formattedFileLists.jack_tools_kit_file.push(file);
          break;
        case 'Door Lock Defect':
          formattedFileLists.door_lock_defect_file = formattedFileLists.door_lock_defect_file || [];
          formattedFileLists.door_lock_defect_file.push(file);
          break;
        case 'Periodic Service':
          formattedFileLists.periodic_service_file = formattedFileLists.periodic_service_file || [];
          formattedFileLists.periodic_service_file.push(file);
          break;
        case 'Carpet Upholstery':
          formattedFileLists.carpet_upholstery_file = formattedFileLists.carpet_upholstery_file || [];
          formattedFileLists.carpet_upholstery_file.push(file);
          break;
        case 'Spare Keys':
          formattedFileLists.spare_keys_file = formattedFileLists.spare_keys_file || [];
          formattedFileLists.spare_keys_file.push(file);
          break;
        case 'Legal Case Resolution':
          formattedFileLists.legal_case_resolution_file = formattedFileLists.legal_case_resolution_file || [];
          formattedFileLists.legal_case_resolution_file.push(file);
          break;
        case 'Original Accessories':
          formattedFileLists.original_accessories_file = formattedFileLists.original_accessories_file || [];
          formattedFileLists.original_accessories_file.push(file);
          break;
        case 'Front Spoiler':
          formattedFileLists.front_spoiler_file = formattedFileLists.front_spoiler_file || [];
          formattedFileLists.front_spoiler_file.push(file);
          break;
        case 'Front Bumper':
          formattedFileLists.front_bumper_file = formattedFileLists.front_bumper_file || [];
          formattedFileLists.front_bumper_file.push(file);
          break;
        case 'Grill':
          formattedFileLists.grill_file = formattedFileLists.grill_file || [];
          formattedFileLists.grill_file.push(file);
          break;
        case 'Rear Bumper':
          formattedFileLists.rear_bumper_file = formattedFileLists.rear_bumper_file || [];
          formattedFileLists.rear_bumper_file.push(file);
          break;
        case 'Rear Spoiler':
          formattedFileLists.rear_spoiler_file = formattedFileLists.rear_spoiler_file || [];
          formattedFileLists.rear_spoiler_file.push(file);
          break;
        case 'Head Light':
          formattedFileLists.head_light_file = formattedFileLists.head_light_file || [];
          formattedFileLists.head_light_file.push(file);
          break;
        case 'Tail Light':
          formattedFileLists.tail_light_file = formattedFileLists.tail_light_file || [];
          formattedFileLists.tail_light_file.push(file);
          break;
        case 'Fog Lamp':
          formattedFileLists.fog_lamp_file = formattedFileLists.fog_lamp_file || [];
          formattedFileLists.fog_lamp_file.push(file);
          break;
        case 'Side Mirror':
          formattedFileLists.side_mirror_file = formattedFileLists.side_mirror_file || [];
          formattedFileLists.side_mirror_file.push(file);
          break;
        case 'Mud Flap':
          formattedFileLists.mud_flap_file = formattedFileLists.mud_flap_file || [];
          formattedFileLists.mud_flap_file.push(file);
          break;
        case 'Windsheild Glass ':
        case 'WindShield Glass':
        case 'Windshield Glass':
          formattedFileLists.windshield_glass_file = formattedFileLists.windshield_glass_file || [];
          formattedFileLists.windshield_glass_file.push(file);
          break;
        case 'Wheel Cover':
          formattedFileLists.wheel_cover_file = formattedFileLists.wheel_cover_file || [];
          formattedFileLists.wheel_cover_file.push(file);
          break;
        case 'Weather Strip':
          formattedFileLists.weather_strip_file = formattedFileLists.weather_strip_file || [];
          formattedFileLists.weather_strip_file.push(file);
          break;
        case 'Logo Missing':
          formattedFileLists.logo_missing_file = formattedFileLists.logo_missing_file || [];
          formattedFileLists.logo_missing_file.push(file);
          break;
        case 'Spare Wheels':
          formattedFileLists.spare_wheels_file = formattedFileLists.spare_wheels_file || [];
          formattedFileLists.spare_wheels_file.push(file);
          break;
        // Step 4 - Interior & Final Inspection file mappings
        case 'Abnormal Noise':
          formattedFileLists.abnormal_noise_file = formattedFileLists.abnormal_noise_file || [];
          formattedFileLists.abnormal_noise_file.push(file);
          break;
        case 'Pedal Handling Defect':
          formattedFileLists.pedal_handling_defect_file = formattedFileLists.pedal_handling_defect_file || [];
          formattedFileLists.pedal_handling_defect_file.push(file);
          break;
        case 'Alignment':
          formattedFileLists.alignment_file = formattedFileLists.alignment_file || [];
          formattedFileLists.alignment_file.push(file);
          break;
        case 'Shock Absorber Defect':
          formattedFileLists.shock_absorber_defect_file = formattedFileLists.shock_absorber_defect_file || [];
          formattedFileLists.shock_absorber_defect_file.push(file);
          break;
        case 'Seat Belt Lock':
          formattedFileLists.seat_belt_lock_file = formattedFileLists.seat_belt_lock_file || [];
          formattedFileLists.seat_belt_lock_file.push(file);
          break;
        case 'Replaced Front Door Panel':
          formattedFileLists.replaced_front_door_panel_file = formattedFileLists.replaced_front_door_panel_file || [];
          formattedFileLists.replaced_front_door_panel_file.push(file);
          break;
        case 'Replaced Rear Door Panel':
          formattedFileLists.replaced_rear_door_panel_file = formattedFileLists.replaced_rear_door_panel_file || [];
          formattedFileLists.replaced_rear_door_panel_file.push(file);
          break;
        case 'Replaced Front Fender Panel':
          formattedFileLists.replaced_front_fender_panel_file = formattedFileLists.replaced_front_fender_panel_file || [];
          formattedFileLists.replaced_front_fender_panel_file.push(file);
          break;
        case 'Replaced Bonnet Hood Panel':
          formattedFileLists.replaced_bonnet_hood_panel_file = formattedFileLists.replaced_bonnet_hood_panel_file || [];
          formattedFileLists.replaced_bonnet_hood_panel_file.push(file);
          break;
        case 'Replaced Trunk Hood Panel':
          formattedFileLists.replaced_trunk_hood_panel_file = formattedFileLists.replaced_trunk_hood_panel_file || [];
          formattedFileLists.replaced_trunk_hood_panel_file.push(file);
          break;
        case 'Front Cross Member':
          formattedFileLists.front_cross_member_file = formattedFileLists.front_cross_member_file || [];
          formattedFileLists.front_cross_member_file.push(file);
          break;
        case 'Upper Core Support':
          formattedFileLists.upper_core_support_file = formattedFileLists.upper_core_support_file || [];
          formattedFileLists.upper_core_support_file.push(file);
          break;
        case 'Core Support':
          formattedFileLists.core_support_file = formattedFileLists.core_support_file || [];
          formattedFileLists.core_support_file.push(file);
          break;
        case 'Rear Wheel House':
          formattedFileLists.rear_wheel_house_file = formattedFileLists.rear_wheel_house_file || [];
          formattedFileLists.rear_wheel_house_file.push(file);
          break;
        case 'Front Side Member':
          formattedFileLists.front_side_member_file = formattedFileLists.front_side_member_file || [];
          formattedFileLists.front_side_member_file.push(file);
          break;
        case 'Front Inside Panel':
          formattedFileLists.front_inside_panel_file = formattedFileLists.front_inside_panel_file || [];
          formattedFileLists.front_inside_panel_file.push(file);
          break;
        case 'Front Pillar':
          formattedFileLists.front_pillar_file = formattedFileLists.front_pillar_file || [];
          formattedFileLists.front_pillar_file.push(file);
          break;
        case 'Center Pillar':
          formattedFileLists.center_pillar_file = formattedFileLists.center_pillar_file || [];
          formattedFileLists.center_pillar_file.push(file);
          break;
        case 'Roof Panel':
          formattedFileLists.roof_panel_file = formattedFileLists.roof_panel_file || [];
          formattedFileLists.roof_panel_file.push(file);
          break;
        case 'Dash Panel':
          formattedFileLists.dash_panel_file = formattedFileLists.dash_panel_file || [];
          formattedFileLists.dash_panel_file.push(file);
          break;
        case 'Floor Cross Member':
          formattedFileLists.floor_cross_member_file = formattedFileLists.floor_cross_member_file || [];
          formattedFileLists.floor_cross_member_file.push(file);
          break;
        case 'Floor Side Member':
          formattedFileLists.floor_side_member_file = formattedFileLists.floor_side_member_file || [];
          formattedFileLists.floor_side_member_file.push(file);
          break;
        case 'Center Floor Panel':
          formattedFileLists.center_floor_panel_file = formattedFileLists.center_floor_panel_file || [];
          formattedFileLists.center_floor_panel_file.push(file);
          break;
        case 'Rear Side Member':
          formattedFileLists.rear_side_member_file = formattedFileLists.rear_side_member_file || [];
          formattedFileLists.rear_side_member_file.push(file);
          break;
        case 'Rear Floor Panel':
          formattedFileLists.rear_floor_panel_file = formattedFileLists.rear_floor_panel_file || [];
          formattedFileLists.rear_floor_panel_file.push(file);
          break;
        case 'Rear Inside Panel':
          formattedFileLists.rear_inside_panel_file = formattedFileLists.rear_inside_panel_file || [];
          formattedFileLists.rear_inside_panel_file.push(file);
          break;
        case 'Rear Cross Member':
          formattedFileLists.rear_cross_member_file = formattedFileLists.rear_cross_member_file || [];
          formattedFileLists.rear_cross_member_file.push(file);
          break;
        case 'Driver Seat':
          formattedFileLists.driver_seat_file = formattedFileLists.driver_seat_file || [];
          formattedFileLists.driver_seat_file.push(file);
          break;
        case 'Co Driver Seat':
          formattedFileLists.co_driver_seat_file = formattedFileLists.co_driver_seat_file || [];
          formattedFileLists.co_driver_seat_file.push(file);
          break;
        case 'Rear Seat':
          formattedFileLists.rear_seats_file = formattedFileLists.rear_seats_file || [];
          formattedFileLists.rear_seats_file.push(file);
          break;
        case 'Sunroof':
          formattedFileLists.sunroof_file = formattedFileLists.sunroof_file || [];
          formattedFileLists.sunroof_file.push(file);
          break;
        case 'Wireless Charger':
          formattedFileLists.wireless_charger_file = formattedFileLists.wireless_charger_file || [];
          formattedFileLists.wireless_charger_file.push(file);
          break;
        case 'Cup Holders':
          formattedFileLists.cup_holders_file = formattedFileLists.cup_holders_file || [];
          formattedFileLists.cup_holders_file.push(file);
          break;
        case 'Glove Box':
          formattedFileLists.glove_box_file = formattedFileLists.glove_box_file || [];
          formattedFileLists.glove_box_file.push(file);
          break;
        case 'Front AC':
          formattedFileLists.front_ac_file = formattedFileLists.front_ac_file || [];
          formattedFileLists.front_ac_file.push(file);
          break;
        case 'Rear AC':
          formattedFileLists.rear_ac_file = formattedFileLists.rear_ac_file || [];
          formattedFileLists.rear_ac_file.push(file);
          break;
        case 'Front Floor Mat':
          formattedFileLists.front_floor_mat_file = formattedFileLists.front_floor_mat_file || [];
          formattedFileLists.front_floor_mat_file.push(file);
          break;
        case 'Rear Floor Mat':
          formattedFileLists.rear_floor_mat_file = formattedFileLists.rear_floor_mat_file || [];
          formattedFileLists.rear_floor_mat_file.push(file);
          break;
        case 'Seat Belt Front':
          formattedFileLists.seat_belts_front_file = formattedFileLists.seat_belts_front_file || [];
          formattedFileLists.seat_belts_front_file.push(file);
          break;
        case 'Seat Belt Rear':
          formattedFileLists.seat_belts_rear_file = formattedFileLists.seat_belts_rear_file || [];
          formattedFileLists.seat_belts_rear_file.push(file);
          break;
        case 'Door Handles Front':
          formattedFileLists.door_handles_front_file = formattedFileLists.door_handles_front_file || [];
          formattedFileLists.door_handles_front_file.push(file);
          break;
        case 'Door Handles Rear':
          formattedFileLists.door_handles_rear_file = formattedFileLists.door_handles_rear_file || [];
          formattedFileLists.door_handles_rear_file.push(file);
          break;
        case 'Interior Cleaning':
          formattedFileLists.interior_cleaning_file = formattedFileLists.interior_cleaning_file || [];
          formattedFileLists.interior_cleaning_file.push(file);
          break;
        case 'Drive Mode Faulty':
          formattedFileLists.drive_mode_faulty_file = formattedFileLists.drive_mode_faulty_file || [];
          formattedFileLists.drive_mode_faulty_file.push(file);
          break;
        case 'Lane Assist Defect':
          formattedFileLists.lane_assist_defect_file = formattedFileLists.lane_assist_defect_file || [];
          formattedFileLists.lane_assist_defect_file.push(file);
          break;
        case 'Hill Assist Defect':
          formattedFileLists.hill_assist_defect_file = formattedFileLists.hill_assist_defect_file || [];
          formattedFileLists.hill_assist_defect_file.push(file);
          break;
        case 'Rear Seats':
          formattedFileLists.rear_seats_file = formattedFileLists.rear_seats_file || [];
          formattedFileLists.rear_seats_file.push(file);
          break;
        case 'Seat Belts Front':
          formattedFileLists.seat_belts_front_file = formattedFileLists.seat_belts_front_file || [];
          formattedFileLists.seat_belts_front_file.push(file);
          break;
        case 'Seat Belts Rear':
          formattedFileLists.seat_belts_rear_file = formattedFileLists.seat_belts_rear_file || [];
          formattedFileLists.seat_belts_rear_file.push(file);
          break;
        default:
          break;
      }
    });

    // Separate Step 2, Step 3, and Step 4 file data
    const step2FileData = {};
    const step3FileData = {};
    const step4FileData = {};
    Object.keys(formattedFileLists).forEach(key => {
      if (key.includes('_file')) {
        // Step 2 file fields (engine, brake, electrical, etc.) - be specific to avoid conflicts
        if (key.includes('engine_oil_leakage') || key.includes('coolant_leakage') || 
            key.includes('radiator_damage') || key.includes('starter_motor_defect') ||
            key.includes('engine_noise') || key.includes('low_pickup') || 
            key.includes('engine_smoke') || key.includes('defective_belts') ||
            key.includes('engine_replaced_endorsed') || key.includes('rough_engine') ||
            key.includes('engine_rpm_defect') || key.includes('brake_disk_damage') ||
            key.includes('brake_defect') || key.includes('abs_ebd_defect') ||
            key.includes('keyless_cylinder_defect') || key.includes('warning_lamp_defect') ||
            key.includes('infotainment_system_defect') || key.includes('head_lamp_defect') ||
            key.includes('fog_lamp_defect') || key.includes('horn_defect') ||
            key.includes('wiper_defect') || key.includes('navigation_system_defect') ||
            key.includes('analog_music_system_defect') || key.includes('cruise_control_defect') ||
            key.includes('steering_wheel_control_defect') || key.includes('electronic_mirror_defect') ||
            key.includes('battery_defect') || key.includes('music_system_defect') ||
            key.includes('power_window_defect') || key.includes('auto_headlight_wiper_defect') ||
            key.includes('electronic_tailgate_defect') || key.includes('parking_sensor_defect') || key.includes('ac_defective') ||
            key.includes('roof_ac') || key.includes('ventilated_seat_defect') ||
            key.includes('electronic_seat_defect') || key.includes('paddle_shift_defect') ||
            key.includes('tyre_pressuring_monitoring_system_defect') || key.includes('sun_roof_defect') ||
            key.includes('rear_view_mirror_irvm') || key.includes('rear_view_mirror_orvm')) {
          step2FileData[key] = formattedFileLists[key];
        }
        // Step 3 file fields (mechanical, exterior, etc.)
        else if (key.includes('clutch') || key.includes('transmission') || key.includes('shift_shock') ||
                 key.includes('gearbox') || key.includes('drive_shaft') || key.includes('boot_cut') ||
                 key.includes('differential') || key.includes('wheel_bearing') || key.includes('wheel_noise_defect') ||
                 key.includes('modified_suspension') || key.includes('steering') || key.includes('jammed') ||
                 key.includes('defective_telescopic') || key.includes('rocker_panel') || key.includes('rear_fender') ||
                 key.includes('end_panel') || key.includes('jack_tools') || key.includes('door_lock') ||
                 key.includes('periodic_service') || key.includes('carpet_upholstery') || key.includes('spare_keys') ||
                 key.includes('legal_case') || key.includes('original_accessories') || key.includes('tyre') ||
                 key.includes('spare_wheels') || key.includes('spoiler') || key.includes('bumper') ||
                 key.includes('grill') || key.includes('head_light') || key.includes('tail_light') ||
                 key.includes('fog_lamp') || key.includes('side_mirror') || key.includes('mud_flap') ||
                 key.includes('windshield_glass') || key.includes('wheel_cover') || key.includes('weather_strip') ||
                 key.includes('logo_missing') || (key.includes('exterior') && key.includes('paint'))) {
          step3FileData[key] = formattedFileLists[key];
        }
        // Step 4 file fields (interior, final inspection, etc.)
        else if (key.includes('abnormal_noise') || key.includes('pedal_handling') || key.includes('alignment') ||
                 key.includes('shock_absorber') || key.includes('seat_belt_lock') || key.includes('replaced_') ||
                 key.includes('front_cross_member') || key.includes('upper_core_support') || key.includes('core_support') ||
                 key.includes('rear_wheel_house') || key.includes('front_side_member') || key.includes('front_inside_panel') ||
                 key.includes('front_pillar') || key.includes('center_pillar') || key.includes('roof_panel') ||
                 key.includes('dash_panel') || key.includes('floor_cross_member') || key.includes('floor_side_member') ||
                 key.includes('center_floor_panel') || key.includes('rear_side_member') || key.includes('rear_floor_panel') ||
                 key.includes('rear_inside_panel') || key.includes('rear_cross_member') || key.includes('driver_seat') ||
                 key.includes('co_driver_seat') || key.includes('rear_seats') || key.includes('sunroof') ||
                 key.includes('wireless_charger') || key.includes('cup_holders') || key.includes('glove_box') ||
                 key.includes('front_ac') || key.includes('rear_ac') || key.includes('front_floor_mat') ||
                 key.includes('rear_floor_mat') || key.includes('seat_belts_front') || key.includes('seat_belts_rear') ||
                 key.includes('door_handles_front') || key.includes('door_handles_rear') || key.includes('interior_cleaning') ||
                 key.includes('drive_mode_faulty') || key.includes('lane_assist_defect') || key.includes('hill_assist_defect')) {
          step4FileData[key] = formattedFileLists[key];
        }
        // Step 1 file fields (keep in fileList)
        else {
          step2FileData[key] = formattedFileLists[key]; // Step 1 fields also go to fileList
        }
      } else {
        // Non-file fields go to fileList (Step 1 fields)
        step2FileData[key] = formattedFileLists[key];
      }
    });
    
    
    // Set fileList with Step 1 and Step 2 data
    setFileList(step2FileData);
    
    // Set fileList3 with Step 3 data
    setFileList3(step3FileData);
    
    // Set fileList4 with Step 4 data
    setFileList4(step4FileData);
  };

  const setBankAndTransferDoc = (exchangeVehicleDetails) => {
    const bankAndTransferDoc = {
      transfer_document: [],
      bank_statement: [],
    };

    const transferDocFile = {
      uid: exchangeVehicleDetails?.id,
      name: exchangeVehicleDetails?.transfer_document_file_name,
      status: 'done',
      url: exchangeVehicleDetails?.transfer_document_file_path,
    };

    const bankStatementFile = {
      uid: exchangeVehicleDetails?.id,
      name: exchangeVehicleDetails?.bank_statement_file_name,
      status: 'done',
      url: exchangeVehicleDetails?.bank_statement_file_path,
    };

    if (exchangeVehicleDetails?.transfer_document_file_path) {
      bankAndTransferDoc.transfer_document.push(transferDocFile);
    }

    if (exchangeVehicleDetails?.bank_statement_file_path) {
      bankAndTransferDoc.bank_statement.push(bankStatementFile);
    }
    setFileList1(bankAndTransferDoc);

    return bankAndTransferDoc;
  };

  useEffect(() => {
    getBankData();
    
    // Helper function to safely create dayjs objects
    const safeDayjs = (dateValue) => {
      if (!dateValue) return null;
      try {
        const dayjsObj = dayjs(dateValue);
        return dayjsObj.isValid() ? dayjsObj : null;
      } catch (error) {
        console.warn('Invalid date value:', dateValue, error);
        return null;
      }
    };

    // Helper function to handle cost values - return 0 if null/undefined
    const getCostValue = (value) => {
      return value !== null && value !== undefined ? value : 0;
    };

    // Delay form initialization to ensure components are ready
    const initializeForm = () => {
      // Only set form values if leadViewDetails exists and form is ready
      if (leadViewDetails && form) {
      try {
        // Create a clean form values object with all Step 1 fields
        const formValues = {
          // Basic vehicle details
          odometer: leadViewDetails?.exchange_vehicle_detail?.odometer,
          exchange_make_id: leadViewDetails?.exchange_vehicle_detail?.make_id,
          exchange_vehicle_model_id: leadViewDetails?.exchange_vehicle_detail?.exchange_vehicle_model_id,
          exchange_vehicle_variant_id: leadViewDetails?.exchange_vehicle_detail?.vehicle_variant_id,
          exchange_fuel_type_id: leadViewDetails?.exchange_vehicle_detail?.fuel_type_id,
          exchange_transmission_id: leadViewDetails?.exchange_vehicle_detail?.exchange_transmission_id,
          customer_type: leadViewDetails?.exchange_vehicle_detail?.customer_type,
          expected_price: leadViewDetails?.exchange_vehicle_detail?.expected_price,
          
          // New fields added
          rc_number: leadViewDetails?.exchange_vehicle_detail?.rc_number,
          emission_type: leadViewDetails?.exchange_vehicle_detail?.emission_type,
          warranty_applicability: leadViewDetails?.exchange_vehicle_detail?.warranty_applicability,
          car_rating: leadViewDetails?.exchange_vehicle_detail?.car_rating,
          transfer_document_file: leadViewDetails?.exchange_vehicle_detail?.transfer_document_file_path,
          
          // Insurance details
          insurance_type: leadViewDetails?.exchange_vehicle_detail?.insurance_type,
          insurance_premium: leadViewDetails?.exchange_vehicle_detail?.insurance_premium,
          company_name: leadViewDetails?.exchange_vehicle_detail?.company_name,
          policy_number: leadViewDetails?.exchange_vehicle_detail?.policy_number,
          idv_value: leadViewDetails?.exchange_vehicle_detail?.idv_value,
          ncb_details: leadViewDetails?.exchange_vehicle_detail?.ncb_details,
          insurance_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.insurance_cost),
          
          // Financial details
          bank_id: leadViewDetails?.exchange_vehicle_detail?.bank_id,
          outstanding_loan: leadViewDetails?.exchange_vehicle_detail?.outstanding_loan,
          foreclose_loan: leadViewDetails?.exchange_vehicle_detail?.foreclose_loan || 'No',
          foreclosure_amount_paid_by_dealer: leadViewDetails?.exchange_vehicle_detail?.foreclosure_amount_paid_by_dealer,
          obv_purchase_value: leadViewDetails?.exchange_vehicle_detail?.obv_purchase_value,
          broker_valuation: leadViewDetails?.exchange_vehicle_detail?.broker_valuation,
          value_offered: leadViewDetails?.exchange_vehicle_detail?.value_offered,
          expected_selling_price: leadViewDetails?.exchange_vehicle_detail?.expected_selling_price,
          
          // Vehicle condition details
          front_body_damage: leadViewDetails?.exchange_vehicle_detail?.front_body_damage,
          right_body_damage: leadViewDetails?.exchange_vehicle_detail?.right_body_damage,
          left_body_damage: leadViewDetails?.exchange_vehicle_detail?.left_body_damage,
          rear_body_damage: leadViewDetails?.exchange_vehicle_detail?.rear_body_damage,
          underbody_damage: leadViewDetails?.exchange_vehicle_detail?.underbody_damage,
          rust_body_damage: leadViewDetails?.exchange_vehicle_detail?.rust_body_damage,
          
          // Refurbishment costs
          front_refurbishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.front_refurbishment_cost),
          right_refurbishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.right_refurbishment_cost),
          left_refurbishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.left_refurbishment_cost),
          rear_refurishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.rear_refurishment_cost),
          underbody_refurishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.underbody_refurishment_cost),
          rust_refurishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.rust_refurishment_cost),
          other_refurishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.other_refurishment_cost),
          total_refurishment_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.total_refurishment_cost),
          
          // Other details
          tools: leadViewDetails?.exchange_vehicle_detail?.tools,
          remarks: leadViewDetails?.exchange_vehicle_detail?.remarks,
          next_follow_up_date: leadViewDetails?.exchange_vehicle_detail?.next_follow_up_date,
          exchange_followup_status_id: leadViewDetails?.exchange_vehicle_detail?.exchange_followup_status_id,
          
          // Step 2 - Functional & Brake Evaluation Details
          engine_oil_leakage: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_oil_leakage,
          engine_oil_leakage_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_oil_leakage_cost),
          coolant_leakage: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.coolant_leakage || 'No',
          coolant_leakage_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.coolant_leakage_cost),
          radiator_damage: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.radiator_damage || 'No',
          radiator_damage_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.radiator_damage_cost),
          starter_motor_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.starter_motor_defect || 'No',
          starter_motor_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.starter_motor_defect_cost),
          engine_noise: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_noise,
          engine_noise_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_noise_cost),
          low_pickup: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.low_pickup,
          low_pickup_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.low_pickup_cost),
          engine_smoke: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_smoke,
          engine_smoke_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_smoke_cost),
          defective_belts: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.defective_belts || 'No',
          defective_belts_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.defective_belts_cost),
          engine_replaced_endorsed: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_replaced_endorsed || 'No',
          engine_replaced_endorsed_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_replaced_endorsed_cost),
          rough_engine: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.rough_engine,
          rough_engine_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.rough_engine_cost),
          engine_rpm_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_rpm_defect,
          engine_rpm_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_rpm_defect_cost),
          brake_disk_damage: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.brake_disk_damage || 'No',
          brake_disk_damage_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.brake_disk_damage_cost),
          brake_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.brake_defect,
          brake_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.brake_defect_cost),
          abs_ebd_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.abs_ebd_defect || 'No',
          abs_ebd_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.abs_ebd_defect_cost),
          keyless_cylinder_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.keyless_cylinder_defect || 'No',
          keyless_cylinder_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.keyless_cylinder_defect_cost),
          warning_lamp_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.warning_lamp_defect,
          warning_lamp_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.warning_lamp_defect_cost),
          infotainment_system_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.infotainment_system_defect,
          infotainment_system_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.infotainment_system_defect_cost),
          head_lamp_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.head_lamp_defect,
          head_lamp_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.head_lamp_defect_cost),
          fog_lamp_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.fog_lamp_defect,
          fog_lamp_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.fog_lamp_defect_cost),
          horn_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.horn_defect,
          horn_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.horn_defect_cost),
          wiper_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.wiper_defect || 'None',
          wiper_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.wiper_defect_cost),
          navigation_system_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.navigation_system_defect || 'No',
          navigation_system_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.navigation_system_defect_cost),
          analog_music_system_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.analog_music_system_defect,
          analog_music_system_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.analog_music_system_defect_cost),
          cruise_control_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.cruise_control_defect || 'No',
          cruise_control_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.cruise_control_defect_cost),
          steering_wheel_control_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.steering_wheel_control_defect,
          steering_wheel_control_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.steering_wheel_control_defect_cost),
          electronic_mirror_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.electronic_mirror_defect,
          electronic_mirror_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.electronic_mirror_defect_cost),
          battery_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.battery_defect,
          battery_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.battery_defect_cost),
          music_system_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.music_system_defect,
          music_system_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.music_system_defect_cost),
          power_window_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.power_window_defect,
          power_window_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.power_window_defect_cost),
          auto_headlight_wiper_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.auto_headlight_wiper_defect || 'No',
          auto_headlight_wiper_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.auto_headlight_wiper_defect_cost),
          electronic_tailgate_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.electronic_tailgate_defect,
          electronic_tailgate_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.electronic_tailgate_defect_cost),
          parking_sensor_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.parking_sensor_defect || 'No',
          parking_sensor_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.parking_sensor_defect_cost),
          ac_defective: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.ac_defective,
          ac_defective_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.ac_defective_cost),
          roof_ac: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.roof_ac || 'No',
          roof_ac_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.roof_ac_cost),
          ventilated_seat_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.ventilated_seat_defect || 'No',
          ventilated_seat_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.ventilated_seat_defect_cost),
          electronic_seat_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.electronic_seat_defect || 'No',
          electronic_seat_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.electronic_seat_defect_cost),
          paddle_shift_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.paddle_shift_defect || 'No',
          paddle_shift_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.paddle_shift_defect_cost),
          tyre_pressuring_monitoring_system_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.tyre_pressuring_monitoring_system_defect || 'No',
          tyre_pressuring_monitoring_system_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.tyre_pressuring_monitoring_system_defect_cost),
          sun_roof_defect: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.sun_roof_defect,
          sun_roof_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.sun_roof_defect_cost),
          rear_view_mirror_irvm: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.rear_view_mirror_irvm || 'No',
          rear_view_mirror_irvm_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.rear_view_mirror_irvm_cost),
          rear_view_mirror_orvm: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.rear_view_mirror_orvm || 'No',
          rear_view_mirror_orvm_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.rear_view_mirror_orvm_cost),
          
          // Functional evaluation details (from exchange_vehicle_functional_evaluation_detail)
          no_of_owners: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.no_of_owners,
          vin_number: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.vin_number,
          vin_plate_available: leadViewDetails?.documents?.some(doc => doc.document_type === 'Vin Plate') ? 'Yes' : (leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.vin_plate_available || 'No'),
          engine_number: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_number,
          rc_book_type: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.rc_book_type,
          registration_date: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.registration_date,
          reregistered_migrated: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.reregistered_migrated || 'No',
          engine_capacity: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.engine_capacity,
          no_of_cylinders: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.no_of_cylinders,
          hp_entry: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.hp_entry,
          noc_available: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.noc_available,
          hp_bank_id: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.hp_bank_id,
          original_invoice_available: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.original_invoice_available || 'No',
          ac_configuration: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.ac_configuration,
          owners_manual_available: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.owners_manual_available || 'No',
          tools_available: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.tools_available || 'No',
          service_history_available: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.service_history_available || 'No',
          legal_case_present: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.legal_case_present || 'No',
          last_service_date: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.last_service_date,
          name_as_on_rc_card: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.name_as_on_rc_card,
          city_registrations_document: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.city_registrations_document || 'No',
          city_registrations_document_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.city_registrations_document_cost),
          accessories_repairs: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.accessories_repairs || 'No',
          accessories_repairs_cost: getCostValue(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.accessories_repairs_cost),
          one_time_road_tax_paid: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.one_time_road_tax_paid || 'No',
          
          // Step 3 - Mechanical & Exterior Details (from exchange_vehicle_mechanical_evaluation_detail)
          clutch_defect: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.clutch_defect,
          clutch_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.clutch_defect_cost),
          transmission_oil_leak: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.transmission_oil_leak || 'No',
          transmission_oil_leak_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.transmission_oil_leak_cost),
          shift_shock_time_lag: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.shift_shock_time_lag,
          shift_shock_time_lag_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.shift_shock_time_lag_cost),
          gearbox_defect: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.gearbox_defect,
          gearbox_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.gearbox_defect_cost),
          drive_shaft_defect: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.drive_shaft_defect || 'No',
          drive_shaft_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.drive_shaft_defect_cost),
          boot_cut: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.boot_cut || 'No',
          boot_cut_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.boot_cut_cost),
          differential_noise: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.differential_noise || 'No',
          differential_noise_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.differential_noise_cost),
          wheel_noise_defect: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.wheel_noise_defect,
          wheel_noise_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.wheel_noise_defect_cost),
          modified_suspension: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.modified_suspension || 'No',
          modified_suspension_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.modified_suspension_cost),
          steering_noise: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.steering_noise,
          steering_noise_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.steering_noise_cost),
          steering_oil_leak: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.steering_oil_leak || 'No',
          steering_oil_leak_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.steering_oil_leak_cost),
          steering_shaft_boot_cut: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.steering_shaft_boot_cut || 'No',
          steering_shaft_boot_cut_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.steering_shaft_boot_cut_cost),
          jammed_steering: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.jammed_steering,
          jammed_steering_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.jammed_steering_cost),
          defective_telescopic_tilt: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.defective_telescopic_tilt || 'No',
          defective_telescopic_tilt_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.defective_telescopic_tilt_cost),
          rh_rocker_panel: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rh_rocker_panel,
          rh_rocker_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rh_rocker_panel_cost),
          lh_rocker_panel: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.lh_rocker_panel,
          lh_rocker_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.lh_rocker_panel_cost),
          rh_rear_fender_panel: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rh_rear_fender_panel,
          rh_rear_fender_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rh_rear_fender_panel_cost),
          lh_rear_fender_panel: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.lh_rear_fender_panel,
          lh_rear_fender_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.lh_rear_fender_panel_cost),
          end_panel: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.end_panel,
          end_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.end_panel_cost),
          jack_tools_kit: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.jack_tools_kit,
          jack_tools_kit_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.jack_tools_kit_cost),
          door_lock_defect: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.door_lock_defect,
          door_lock_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.door_lock_defect_cost),
          periodic_service: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.periodic_service,
          periodic_service_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.periodic_service_cost),
          carpet_upholstery: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.carpet_upholstery,
          carpet_upholstery_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.carpet_upholstery_cost),
          spare_keys: leadViewDetails?.exchange_vehicle_detail?.spare_keys,
          spare_keys_cost: getCostValue(leadViewDetails?.exchange_vehicle_detail?.spare_keys_cost),
          legal_case_resolution: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.legal_case_resolution,
          legal_case_resolution_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.legal_case_resolution_cost),
          original_accessories: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.original_accessories,
          original_accessories_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.original_accessories_cost),
          front_tyre_left: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_tyre_left,
          front_tyre_left_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_tyre_left_cost),
          front_tyre_right: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_tyre_right,
          front_tyre_right_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_tyre_right_cost),
          back_tyre_left: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.back_tyre_left,
          back_tyre_left_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.back_tyre_left_cost),
          back_tyre_right: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.back_tyre_right,
          back_tyre_right_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.back_tyre_right_cost),
          spare_wheels: leadViewDetails?.exchange_vehicle_detail?.spare_wheels,
          spare_wheels_cost:getCostValue(leadViewDetails?.exchange_vehicle_detail?.spare_wheels_cost),
          front_spoiler: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_spoiler || 'Ok',
          front_spoiler_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_spoiler_cost),
          front_bumper: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_bumper,
          front_bumper_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.front_bumper_cost),
          grill: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.grill,
          grill_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.grill_cost),
          rear_bumper: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rear_bumper,
          rear_bumper_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rear_bumper_cost),
          rear_spoiler: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rear_spoiler || 'Ok',
          rear_spoiler_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.rear_spoiler_cost),
          head_light: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.head_light,
          head_light_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.head_light_cost),
          tail_light: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.tail_light,
          tail_light_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.tail_light_cost),
          fog_lamp: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.fog_lamp,
          fog_lamp_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.fog_lamp_cost),
          side_mirror: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.side_mirror,
          side_mirror_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.side_mirror_cost),
          mud_flap: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.mud_flap || 'Ok',
          mud_flap_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.mud_flap_cost),
          windshield_glass: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.windshield_glass,
          windshield_glass_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.windshield_glass_cost),
          wheel_cover: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.wheel_cover || 'Ok',
          wheel_cover_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.wheel_cover_cost),
          weather_strip: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.weather_strip || 'Ok',
          weather_strip_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.weather_strip_cost),
          logo_missing: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.logo_missing || 'Ok',
          logo_missing_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.logo_missing_cost),
          exterior_front_paint: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_front_paint || 'Ok',
          exterior_front_paint_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_front_paint_cost),
          exterior_left_paint: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_left_paint || 'Ok',
          exterior_left_paint_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_left_paint_cost),
          exterior_right_paint: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_right_paint || 'Ok',
          exterior_right_paint_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_right_paint_cost),
          exterior_rear_paint: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_rear_paint || 'Ok',
          exterior_rear_paint_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_rear_paint_cost),
          exterior_top_paint: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_top_paint || 'Ok',
          exterior_top_paint_cost: getCostValue(leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_top_paint_cost),
          exterior_other_observation_remarks: leadViewDetails?.exchange_vehicle_mechanical_evaluation_detail?.exterior_other_observation_remarks,
          
          // Step 4 - Interior & Final Inspection Details
          abnormal_noise: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.abnormal_noise,
          abnormal_noise_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.abnormal_noise_cost),
          pedal_handling_defect: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.pedal_handling_defect,
          pedal_handling_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.pedal_handling_defect_cost),
          alignment: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.alignment,
          alignment_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.alignment_cost),
          shock_absorber_defect: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.shock_absorber_defect,
          shock_absorber_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.shock_absorber_defect_cost),
          seat_belt_lock: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.seat_belt_lock,
          seat_belt_lock_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.seat_belt_lock_cost),
          drive_mode_faulty: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.drive_mode_faulty,
          drive_mode_faulty_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.drive_mode_faulty_cost),
          lane_assist_defect: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.lane_assist_defect,
          lane_assist_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.lane_assist_defect_cost),
          hill_assist_defect: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.hill_assist_defect,
          hill_assist_defect_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.hill_assist_defect_cost),
          replaced_front_door_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_front_door_panel,
          replaced_front_door_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_front_door_panel_cost),
          replaced_rear_door_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_rear_door_panel,
          replaced_rear_door_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_rear_door_panel_cost),
          replaced_front_fender_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_front_fender_panel,
          replaced_front_fender_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_front_fender_panel_cost),
          replaced_bonnet_hood_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_bonnet_hood_panel,
          replaced_bonnet_hood_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_bonnet_hood_panel_cost),
          replaced_trunk_hood_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_trunk_hood_panel,
          replaced_trunk_hood_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.replaced_trunk_hood_panel_cost),
          front_cross_member: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_cross_member,
          front_cross_member_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_cross_member_cost),
          upper_core_support: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.upper_core_support,
          upper_core_support_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.upper_core_support_cost),
          core_support: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.core_support || 'Ok',
          core_support_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.core_support_cost),
          rear_wheel_house: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_wheel_house || 'Ok',
          rear_wheel_house_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_wheel_house_cost),
          front_side_member: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_side_member || 'Ok',
          front_side_member_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_side_member_cost),
          front_inside_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_inside_panel || 'Ok',
          front_inside_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_inside_panel_cost),
          front_pillar: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_pillar,
          front_pillar_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_pillar_cost),
          center_pillar: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.center_pillar,
          center_pillar_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.center_pillar_cost),
          roof_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.roof_panel,
          roof_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.roof_panel_cost),
          dash_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.dash_panel || 'Ok',
          dash_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.dash_panel_cost),
          floor_cross_member: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.floor_cross_member || 'Ok',
          floor_cross_member_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.floor_cross_member_cost),
          floor_side_member: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.floor_side_member || 'Ok',
          floor_side_member_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.floor_side_member_cost),
          center_floor_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.center_floor_panel || 'Ok',
          center_floor_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.center_floor_panel_cost),
          rear_side_member: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_side_member || 'Ok',
          rear_side_member_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_side_member_cost),
          rear_floor_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_floor_panel || 'Ok',
          rear_floor_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_floor_panel_cost),
          rear_inside_panel: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_inside_panel || 'Ok',
          rear_inside_panel_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_inside_panel_cost),
          rear_cross_member: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_cross_member || 'Ok',
          rear_cross_member_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_cross_member_cost),
          driver_seat: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.driver_seat || 'Ok',
          driver_seat_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.driver_seat_cost),
          no_of_seats: leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.no_of_seats,
          co_driver_seat: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.co_driver_seat || 'Ok',
          co_driver_seat_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.co_driver_seat_cost),
          rear_seats: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_seats || 'Ok',
          rear_seats_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_seats_cost),
          sunroof: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.sunroof,
          sunroof_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.sunroof_cost),
          wireless_charger: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.wireless_charger || 'Ok',
          wireless_charger_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.wireless_charger_cost),
          cup_holders: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.cup_holders || 'Ok',
          cup_holders_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.cup_holders_cost),
          glove_box: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.glove_box || 'Ok',
          glove_box_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.glove_box_cost),
          front_ac: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_ac,
          front_ac_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_ac_cost),
          rear_ac: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_ac || 'Ok',
          rear_ac_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_ac_cost),
          front_floor_mat: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_floor_mat || 'Ok',
          front_floor_mat_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.front_floor_mat_cost),
          rear_floor_mat: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_floor_mat || 'Ok',
          rear_floor_mat_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.rear_floor_mat_cost),
          seat_belts_front: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.seat_belts_front || 'Ok',
          seat_belts_front_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.seat_belts_front_cost),
          seat_belts_rear: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.seat_belts_rear || 'Ok',
          seat_belts_rear_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.seat_belts_rear_cost),
          door_handles_front: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.door_handles_front || 'Ok',
          door_handles_front_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.door_handles_front_cost),
          door_handles_rear: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.door_handles_rear || 'Ok',
          door_handles_rear_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.door_handles_rear_cost),
          interior_cleaning: leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.interior_cleaning || 'Ok',
          interior_cleaning_cost: getCostValue(leadViewDetails?.exchange_vehicle_interior_final_evaluation_detail?.interior_cleaning_cost),
        };

        // Set non-date fields first
        form.setFieldsValue(formValues);

        // Set file upload fields with default values from documents
        const setFileFieldValues = () => {
          const fileFieldValues = {};
          
          // Set insurance document if exists
          const insuranceDoc = leadViewDetails?.documents?.find(doc => 
            doc.document_type === 'Insurance Policy' || doc.document_type === 'Insurance Document'
          );
          if (insuranceDoc) {
            fileFieldValues.insurance_document = [{
              uid: insuranceDoc.id,
              name: insuranceDoc.document_file_name,
              status: 'done',
              url: insuranceDoc.document_path,
            }];
          }

          // Set odometer document if exists
          const odometerDoc = leadViewDetails?.documents?.find(doc => doc.document_type === 'Odometer Reading');
          if (odometerDoc) {
            fileFieldValues.odometer_document = [{
              uid: odometerDoc.id,
              name: odometerDoc.document_file_name,
              status: 'done',
              url: odometerDoc.document_path,
            }];
          }

          // Set engine number document if exists
          const engineDoc = leadViewDetails?.documents?.find(doc => doc.document_type === 'Engine Number');
          if (engineDoc) {
            fileFieldValues.engine_number_document = [{
              uid: engineDoc.id,
              name: engineDoc.document_file_name,
              status: 'done',
              url: engineDoc.document_path,
            }];
          }

          // Set city registrations document if exists
          const cityRegDoc = leadViewDetails?.documents?.find(doc => 
            doc.document_type === 'City Registrations Document' || doc.document_type === 'City Registration'
          );
          if (cityRegDoc) {
            fileFieldValues.city_registrations_document_file = [{
              uid: cityRegDoc.id,
              name: cityRegDoc.document_file_name,
              status: 'done',
              url: cityRegDoc.document_path,
            }];
          }

          // Set front RC document if exists
          const frontRCDoc = leadViewDetails?.documents?.find(doc => 
            doc.document_type === 'EXCHANGE_FRONT_RC' || doc.document_type === 'Exchange Front RC'
          );
          if (frontRCDoc) {
            fileFieldValues.copy_of_front_rc = [{
              uid: frontRCDoc.id,
              name: frontRCDoc.document_file_name,
              status: 'done',
              url: frontRCDoc.document_path,
            }];
          }

          // Set back RC document if exists
          const backRCDoc = leadViewDetails?.documents?.find(doc => 
            doc.document_type === 'EXCHANGE_BACK_RC' || doc.document_type === 'Exchange Back RC'
          );
          if (backRCDoc) {
            fileFieldValues.copy_of_back_rc = [{
              uid: backRCDoc.id,
              name: backRCDoc.document_file_name,
              status: 'done',
              url: backRCDoc.document_path,
            }];
          }

          // Set the file field values
          if (Object.keys(fileFieldValues).length > 0) {
            form.setFieldsValue(fileFieldValues);
          }
        };

        setFileFieldValues();

        // Set date fields separately with validation
        const yearValue = safeDayjs(leadViewDetails?.exchange_vehicle_detail?.car_year);
        const insuranceValue = safeDayjs(leadViewDetails?.exchange_vehicle_detail?.insurance_validity);
        const registrationDateValue = safeDayjs(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.registration_date);
        const lastServiceDateValue = safeDayjs(leadViewDetails?.exchange_vehicle_functional_evaluation_detail?.last_service_date);
        const nextFollowUpDateValue = safeDayjs(leadViewDetails?.exchange_vehicle_detail?.next_follow_up_date);
        
        if (yearValue) {
          form.setFieldValue('year', yearValue);
        }
        if (insuranceValue) {
          form.setFieldValue('insurance_validity', insuranceValue);
        }
        if (registrationDateValue) {
          form.setFieldValue('registration_date', registrationDateValue);
        }
        if (lastServiceDateValue) {
          form.setFieldValue('last_service_date', lastServiceDateValue);
        }
        if (nextFollowUpDateValue) {
          form.setFieldValue('next_follow_up_date', nextFollowUpDateValue);
        }

      } catch (error) {
        console.error('Error setting form values:', error);
      }
      
        setUploadComponentData(leadViewDetails?.documents);
        setBankAndTransferDoc(leadViewDetails?.exchange_vehicle_detail);
      }
    };

    // Use setTimeout to delay initialization
    const timeoutId = setTimeout(() => {
      initializeForm();
      
      // Trigger validation after form initialization to show validation errors for pre-filled data
      setTimeout(() => {
        if (form) {
          // Validate all fields to trigger validation errors for pre-filled data
          form.validateFields().catch((errorInfo) => {
            // Log validation errors for debugging
            console.log('Validation errors:', errorInfo);
          });
        }
      }, 500); // Increased timeout to ensure form is fully rendered
    }, 100);
    
    return () => clearTimeout(timeoutId);
  }, [leadViewDetails]);

  // Trigger validation when navigating to Step 3 (index 2)
  useEffect(() => {
    if (currentStep === 2 && form) {
      // Small delay to ensure Step 3 component is fully rendered
      setTimeout(() => {
        form.validateFields().catch((errorInfo) => {
          console.log('Step 3 validation errors:', errorInfo);
        });
      }, 300);
    }
  }, [currentStep, form]);

  const getBankData = async () => {
    setIsLoading(true);
    try {
      const modalDataArray = await getBankerService(true);
      setBankerList(modalDataArray?.data?.data);
    } catch (error) {
      notification.error({
        message: error.response?.data?.message ?? error?.message,
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const calculateTotal = (values) => {
    const fields = [
      'front_refurbishment_cost',
      'right_refurbishment_cost',
      'left_refurbishment_cost',
      'rear_refurishment_cost',
      'underbody_refurishment_cost',
      'rust_refurishment_cost',
      'other_refurishment_cost',
    ];

    const totalSum = fields.reduce((sum, field) => {
      const value = parseFloat(values[field]) || 0;
      return sum + value;
    }, 0);

    setTotal(totalSum);
  };

  useEffect(() => {
    form.setFieldsValue({ total_refurishment_cost: total });
  }, [total, form]);

  const onSubmit = async (values, type) => {
    setIsLoading(true);
    // Get action from state (set by button clicks)
    const action = type;

    try {
      // Call Step 4 API similar to other steps
      const step4FormData = new FormData();
      
      // Append all form fields to step4FormData
      Object.keys(values).forEach(key => {
        if (values[key] !== undefined && values[key] !== null) {
          // Handle file uploads
          if (Array.isArray(values[key]) && values[key].length > 0 && values[key][0].originFileObj) {
            // This is a file upload field
            values[key].forEach((file) => {
              if (file.originFileObj) {
                step4FormData.append(key, file.originFileObj);
              }
            });
          } else if (values[key] && typeof values[key] === 'object' && values[key].format) {
            // This is a date field (dayjs object)
            step4FormData.append(key, values[key].format('YYYY-MM-DD'));
          } else if (Array.isArray(values[key])) {
            // Handle multi-select fields (excluding interior_cleaning which is now single select)
            if (key !== 'interior_cleaning') {
              values[key].forEach((item) => {
                step4FormData.append(key, item);
              });
            } else {
              step4FormData.append(key, values[key]);
            }
          } else {
            // Regular field
            step4FormData.append(key, values[key]);
          }
        }
      });
      
      // Add current_form_step for Step 4
      step4FormData.append('current_form_step', '4');
      
      // Add id key
      step4FormData.append('id', leadViewDetails?.exchange_vehicle_detail?.id);
      
      // Add exchange stage IDs based on exchange_stage_history
      const exchangeStageHistory = leadViewDetails?.exchange_stage_history || [];
      
      // Find the current "In Progress" stage
      const currentInProgressStage = exchangeStageHistory.find(stage => stage.status === 1);
      const currentInProgressStageId = currentInProgressStage?.lead_exchange_stage_id;
      let nextExchangeStageId;
      
      // Handle stage transitions based on current in-progress stage and action
      if (currentInProgressStageId === 2) {
        // Pre evaluation stage: exchange_stage_id: 2, next_exchange_stage_id: 3
        nextExchangeStageId = 3;
      } else if (currentInProgressStageId === 3) {
        // Quality Inspection stage
        if (action === 'approve') {
          // Approve: exchange_stage_id: 3, next_exchange_stage_id: 5
          nextExchangeStageId = 5;
        } else if (action === 'reject') {
          // Reject: exchange_stage_id: 3, next_exchange_stage_id: 4
          nextExchangeStageId = 4;
        } else {
          nextExchangeStageId = 3; // Default for submit
        }
      } else if (currentInProgressStageId === 4) {
        // Re-Evaluation stage: exchange_stage_id: 4, next_exchange_stage_id: 3
        nextExchangeStageId = 3;
      } else if (currentInProgressStageId === 6) {
        // Pre Final Assessment stage 6 -> next stage 7
        nextExchangeStageId = 7;
      } else if (currentInProgressStageId === 7) {
        // Final Assessment stage 7 -> next is null
        nextExchangeStageId = null;
      } else {
        // Default behavior: Find the next stage after the current "In Progress" stage
        const nextStage = exchangeStageHistory.find(stage => 
          stage.lead_exchange_stage_id === currentInProgressStageId + 1
        );
        nextExchangeStageId = nextStage?.lead_exchange_stage_id;
      }
      
      // Add exchange stage IDs to form data
      if (currentInProgressStageId) {
        step4FormData.append('exchange_stage_id', currentInProgressStageId);
      }
      if (nextExchangeStageId !== undefined && nextExchangeStageId !== null) {
        step4FormData.append('next_exchange_stage_id', nextExchangeStageId);
      }
      
      
      
      // Call Step 4 API
      const response = await saveExchangeStep4DraftService(step4FormData);
      if (response?.data?.status === API_RESPONSE_CODES.OK) {
        notification.success({
          message: response?.data?.message || (action === 'reject' ? 'Lead rejected successfully.' : 'Step 4 completed successfully. Pre evaluation stage marked as completed.'),
        });
        
        // Reset form data
        form.resetFields();
        
        // Fetch updated lead details
        await dispatch(fetchLeadDetailsServices({ id: id }));
        
        // Handle redirect based on action
        if (action === 'reject') {
          // Ensure API fetch completes before navigating via state
          // Navigate to Step 1 form view without full page reload
          setCurrentStep(0);
          setIsOTPVerified(true); // skip OTP for this flow
          setShowDetailsPage(false);
          setShowLoader(true);
          setTimeout(() => {
            setShowLoader(false);
          }, 1000);
        } else {
          // For approve: show details page
          setShowDetailsPage(true);
        }
      }
    } catch (error) {
      notification.error({
        message: error.response?.data?.message ?? error?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    // Check if Pre evaluation is completed (stage 2 with status 2)
    const isPreEvaluationCompleted = leadViewDetails?.exchange_stage_history?.find(stage => 
      stage.lead_exchange_stage_id === 2 && stage.status === 2
    );
    
    if (isPreEvaluationCompleted) {
      // Pre evaluation is completed - go to Step1DetailsSection
      setShowDetailsPage(true);
      setShowExchangeDetails(false);
    } else {
      // Pre evaluation is not completed - go to ExchangeEvaluationDetails
      setShowDetailsPage(false);
      setShowExchangeDetails(true);
    }
  };


  const getStepFields = (step) => {
    switch (step) {
      case 0: // Step 1 - Vehicle & Insurance Details
        return [
          'odometer', 'odometer_document', 'no_of_owners', 'vin_number', 'vin_plate_available', 
          'vin_plate_document', 'rc_book_type', 
          'registration_date', 'reregistered_migrated',
          'hp_entry', 'noc_available', 'bank_id', 'original_invoice_available', 
          'owners_manual_available', 'tools_available', 'service_history_available', 
          'legal_case_present', 'last_service_date', 'customer_type', 'name_as_on_rc_card', 
          'expected_price', 'insurance_type',  'insurance_validity', 
          'company_name', 'idv_value', 'ncb_details', 
        'city_registrations_document', 'city_registrations_document_file',
          'accessories_repairs', 'accessories_repairs_document', 'one_time_road_tax_paid', 
          'foreclose_loan', 'foreclosure_amount_paid_by_dealer',
          'obv_purchase_value',  'value_offered', 'next_follow_up_date', 'exchange_followup_status_id',
          'emission_type', 'warranty_applicability','car_rating', 'rc_number','copy_of_front_rc', 'copy_of_back_rc',
          'exterior_front', 'exterior_left', 'exterior_right', 'exterior_back',
          'interior_front', 'interior_back', 'bonnet_open', 'boot_open'
        ];
      case 1: // Step 2 - Functional & Brake Evaluation
        return [
          'engine_oil_leakage', 'engine_noise', 'low_pickup', 'engine_smoke', 'engine_replaced_endorsed',
          'brake_defect', 'keyless_cylinder_defect', 'warning_lamp_defect', 'infotainment_system_defect',
          'head_lamp_defect', 'fog_lamp_defect', 'horn_defect', 'wiper_defect', 'navigation_system_defect',
          'analog_music_system_defect', 'cruise_control_defect', 'steering_wheel_control_defect',
          'electronic_mirror_defect', 'music_system_defect', 'power_window_defect',
          'auto_headlight_wiper_defect', 'electronic_tailgate_defect', 'parking_sensor_defect', 'ac_defective', 'roof_ac',
          'ventilated_seat_defect', 'electronic_seat_defect', 'paddle_shift_defect',
          'tyre_pressuring_monitoring_system_defect', 'sun_roof_defect', 'rear_view_mirror_irvm', 'rear_view_mirror_orvm'
        ];
      case 2: // Step 3 - Mechanical & Exterior Details
        return [
          'clutch_defect', 'clutch_defect_cost', 'clutch_defect_file', 'transmission_oil_leak', 'transmission_oil_leak_cost', 'transmission_oil_leak_file',
          'shift_shock_time_lag', 'shift_shock_time_lag_cost', 'shift_shock_time_lag_file', 'gearbox_defect', 'gearbox_defect_cost', 'gearbox_defect_file',
          'drive_shaft_defect', 'drive_shaft_defect_cost', 'drive_shaft_defect_file', 'boot_cut', 'boot_cut_cost', 'boot_cut_file',
          'differential_noise', 'differential_noise_cost', 'differential_noise_file', 'wheel_noise_defect', 'wheel_noise_defect_cost', 'wheel_noise_defect_file',
          'modified_suspension', 'modified_suspension_cost', 'modified_suspension_file', 'steering_noise', 'steering_noise_cost', 'steering_noise_file',
          'steering_oil_leak', 'steering_oil_leak_cost', 'steering_oil_leak_file', 'steering_shaft_boot_cut', 'steering_shaft_boot_cut_cost', 'steering_shaft_boot_cut_file',
          'jammed_steering', 'jammed_steering_cost', 'jammed_steering_file', 'defective_telescopic_tilt', 'defective_telescopic_tilt_cost', 'defective_telescopic_tilt_file',
          'rh_rocker_panel', 'rh_rocker_panel_cost', 'rh_rocker_panel_file', 'lh_rocker_panel', 'lh_rocker_panel_cost', 'lh_rocker_panel_file',
          'rh_rear_fender_panel', 'rh_rear_fender_panel_cost', 'rh_rear_fender_panel_file', 'lh_rear_fender_panel', 'lh_rear_fender_panel_cost', 'lh_rear_fender_panel_file',
          'end_panel', 'end_panel_cost', 'end_panel_file', 'jack_tools_kit', 'jack_tools_kit_cost', 'jack_tools_kit_file',
          'door_lock_defect', 'door_lock_defect_cost', 'door_lock_defect_file', 'periodic_service', 'periodic_service_cost', 'periodic_service_file',
          'carpet_upholstery', 'carpet_upholstery_cost', 'carpet_upholstery_file', 'spare_keys', 'spare_keys_cost', 'spare_keys_file',
          'legal_case_resolution', 'legal_case_resolution_cost', 'legal_case_resolution_file', 'original_accessories', 'original_accessories_cost', 'original_accessories_file',
          'front_tyre_left', 'front_tyre_left_cost', 'front_tyre_left_file', 'front_tyre_right', 'front_tyre_right_cost', 'front_tyre_right_file',
          'back_tyre_left', 'back_tyre_left_cost', 'back_tyre_left_file', 'back_tyre_right', 'back_tyre_right_cost', 'back_tyre_right_file',
          'spare_wheels', 'spare_wheels_cost', 'spare_wheels_file', 'front_spoiler', 'front_spoiler_cost', 'front_spoiler_file',
          'front_bumper', 'front_bumper_cost', 'front_bumper_file', 'grill', 'grill_cost', 'grill_file',
          'rear_bumper', 'rear_bumper_cost', 'rear_bumper_file', 'rear_spoiler', 'rear_spoiler_cost', 'rear_spoiler_file',
          'head_light', 'head_light_cost', 'head_light_file', 'tail_light', 'tail_light_cost', 'tail_light_file',
          'fog_lamp', 'fog_lamp_cost', 'fog_lamp_file', 'side_mirror', 'side_mirror_cost', 'side_mirror_file',
          'mud_flap', 'mud_flap_cost', 'mud_flap_file', 'windshield_glass', 'windshield_glass_cost', 'windshield_glass_file',
          'wheel_cover', 'wheel_cover_cost', 'wheel_cover_file', 'weather_strip', 'weather_strip_cost', 'weather_strip_file',
          'logo_missing', 'logo_missing_cost', 'logo_missing_file', 'exterior_front_paint', 'exterior_front_paint_cost', 'exterior_front_paint_file',
          'exterior_left_paint', 'exterior_left_paint_cost', 'exterior_left_paint_file', 'exterior_right_paint', 'exterior_right_paint_cost', 'exterior_right_paint_file',
          'exterior_rear_paint', 'exterior_rear_paint_cost', 'exterior_rear_paint_file', 'exterior_top_paint', 'exterior_top_paint_cost', 'exterior_top_paint_file',
          'exterior_other_observation_remarks'
        ];
      case 3: // Step 4 - Interior & Final Inspection
        return [
          'abnormal_noise', 'pedal_handling_defect', 'seat_belt_lock', 'drive_mode_faulty',
          'lane_assist_defect', 'replaced_front_door_panel', 'replaced_rear_door_panel',
          'replaced_front_fender_panel', 'replaced_bonnet_hood_panel', 'replaced_trunk_hood_panel',
          'front_pillar', 'center_pillar', 'roof_panel', 'dash_panel', 'floor_cross_member',
          'floor_side_member', 'center_floor_panel', 'rear_side_member', 'rear_floor_panel',
          'rear_inside_panel', 'rear_cross_member', 'driver_seat', 'co_driver_seat', 'rear_seats',
          'sunroof', 'wireless_charger', 'cup_holders', 'glove_box', 'front_ac', 'rear_ac',
          'front_floor_mat', 'rear_floor_mat', 'seat_belts_front', 'seat_belts_rear',
          'door_handles_front', 'door_handles_rear'
        ];
      default:
        return [];
    }
  };

  const saveAndContinue = async () => {
    // Get current step fields for validation
    let stepFields = getStepFields(currentStep);
    
    // For Step 2, include dynamic dependent fields (cost/file) based on current selections
    if (currentStep === 1) {
      const currentValues = form.getFieldsValue();
      const addIfNeeded = (fieldName, predicate) => {
        const v = currentValues[fieldName];
        if (predicate(v)) {
          stepFields = stepFields.concat([`${fieldName}_cost`, `${fieldName}_file`]);
        }
      };
      // Default rule: require when value === 'Yes'
      const yesRule = (v) => v === 'Yes';
      // Special rules
      const notNone = (v) => v && v !== 'None';
      const notOk = (v) => v && v !== 'Ok';

      [
        'engine_oil_leakage','engine_noise','low_pickup','engine_replaced_endorsed','brake_defect','keyless_cylinder_defect',
        'warning_lamp_defect','head_lamp_defect','fog_lamp_defect','horn_defect','navigation_system_defect',
        'analog_music_system_defect','cruise_control_defect','steering_wheel_control_defect','electronic_mirror_defect',
        'music_system_defect','power_window_defect','auto_headlight_wiper_defect','electronic_tailgate_defect','parking_sensor_defect',
        'ac_defective','roof_ac','ventilated_seat_defect','electronic_seat_defect','paddle_shift_defect',
        'tyre_pressuring_monitoring_system_defect','sun_roof_defect','rear_view_mirror_irvm','rear_view_mirror_orvm',
        'battery_defect'
      ].forEach((f) => addIfNeeded(f, yesRule));
      addIfNeeded('engine_smoke', notNone);
      addIfNeeded('infotainment_system_defect', notOk);
      addIfNeeded('wiper_defect', notNone);
    }
    
    // Validate current step fields only
    form.validateFields(stepFields).then(async () => {
      if (currentStep === 0) {
        // Step 1 - call the specific API
        setIsSaving(true);
        try {
          const values = form.getFieldsValue();
          const formData = new FormData();
          
          // Append all Step 1 fields to formData
         Object.keys(values).forEach(key => {
          const val = values[key];
          if (val === undefined || val === null) return;
                  if (Array.isArray(val)) {
            val.forEach((file) => {
              if (!file) return;
        
              if (file.originFileObj) {
                // 🆕 New file → send as binary
                formData.append(key, file.originFileObj);
              } 
              
            });
            return;
          }
        
          if (val && typeof val === 'object' && typeof val.format === 'function') {
            formData.append(key, val.format('YYYY-MM-DD'));
            return;
          }
        
          if (val && typeof val === 'object') {
            formData.append(key, JSON.stringify(val));
            return;
          }
        
          formData.append(key, val);
        });
        

          // Add exchange_stage_id from In Progress status
          const inProgressStage = leadViewDetails?.exchange_stage_history?.find(item => item.status_name === 'In Progress');
          if (inProgressStage) {
            formData.append('exchange_stage_id', inProgressStage.lead_exchange_stage_id);
          }
          
          // Add current_form_step for Step 1
          formData.append('current_form_step', '1');
          
          // Add id key
          formData.append('id', leadViewDetails?.exchange_vehicle_detail?.id);
          const response = await saveExchangeStep1DraftService(formData);
          if (response?.data?.status === API_RESPONSE_CODES.OK) {
            notification.success({
              message: response?.data?.message || 'Step 1 saved successfully',
            });
            
            // Reset form data
            form.resetFields();
            
            // Fetch updated lead details
            try {
              await dispatch(fetchLeadDetailsServices({ id: id }));
            } catch (error) {
              console.warn('Failed to refresh lead details:', error);
            }
            
            // Move to next step
            setCurrentStep(currentStep + 1);
          }
        } catch (error) {
          notification.error({
            message: error?.response?.data?.message,
          });
        } finally {
          setIsSaving(false);
        }
      } else if (currentStep === 1) {
        // Step 2 - call the specific API
        setIsSaving(true);
        try {
          const values = form.getFieldsValue();
          const formData = new FormData();
          
          // Append all Step 2 fields to formData
          Object.keys(values).forEach(key => {
            if (values[key] !== undefined && values[key] !== null) {
              // Handle file uploads
              if (Array.isArray(values[key]) && values[key].length > 0 && values[key][0].originFileObj) {
                // This is a file upload field
                values[key].forEach((file) => {
                  if (file.originFileObj) {
                    formData.append(key, file.originFileObj);
                  }
                });
              } else if (values[key] && typeof values[key] === 'object' && values[key].format) {
                // This is a date field (dayjs object)
                formData.append(key, values[key].format('YYYY-MM-DD'));
              } else {
                // Regular field
                formData.append(key, values[key]);
              }
            }
          });
          // Add current_form_step for Step 2
          formData.append('current_form_step', '2');
          
          // Add id key
          formData.append('id', leadViewDetails?.exchange_vehicle_detail?.id);
          
          const response = await saveExchangeStep2DraftService(formData);
          if (response?.data?.status === API_RESPONSE_CODES.OK) {
            notification.success({
              message: response?.data?.message || 'Step 2 saved successfully',
            });
            
            // Reset form data
            form.resetFields();
            
            // Fetch updated lead details
            try {
              await dispatch(fetchLeadDetailsServices({ id: id }));
            } catch (error) {
              console.warn('Failed to refresh lead details:', error);
            }
            
            // Move to next step
            setCurrentStep(currentStep + 1);
          }
        } catch (error) {
          notification.error({
            message: error?.response?.data?.message,
          });
        } finally {
          setIsSaving(false);
        }
      } else if (currentStep === 2) {
        // Step 3 - call the specific API
        setIsSaving(true);
        try {
          const values = form.getFieldsValue();
          const formData = new FormData();
          
          // Append all Step 3 fields to formData
          Object.keys(values).forEach(key => {
            if (values[key] !== undefined && values[key] !== null) {
              // Handle file uploads
              if (Array.isArray(values[key]) && values[key].length > 0 && values[key][0].originFileObj) {
                // This is a file upload field
                values[key].forEach((file) => {
                  if (file.originFileObj) {
                    formData.append(key, file.originFileObj);
                  }
                });
              } else if (values[key] && typeof values[key] === 'object' && values[key].format) {
                // This is a date field (dayjs object)
                formData.append(key, values[key].format('YYYY-MM-DD'));
              } else {
                // Regular field
                formData.append(key, values[key]);
              }
            }
          });
          
          // Add current_form_step for Step 3
          formData.append('current_form_step', '3');
          
          // Add id key
          formData.append('id', leadViewDetails?.exchange_vehicle_detail?.id);
          
          const response = await saveExchangeStep3DraftService(formData);
          if (response?.data?.status === API_RESPONSE_CODES.OK) {
            notification.success({
              message: response?.data?.message || 'Step 3 saved successfully',
            });
            
            // Reset form data
            form.resetFields();
            
            // Fetch updated lead details
            try {
              await dispatch(fetchLeadDetailsServices({ id: id }));
            } catch (error) {
              console.warn('Failed to refresh lead details:', error);
            }
            
            // Move to next step
            setCurrentStep(currentStep + 1);
          }
        } catch (error) {
          notification.error({
            message: error?.response?.data?.message,
          });
        } finally {
          setIsSaving(false);
        }
      } else {
        // Other steps - just move to next step
        setCurrentStep(currentStep + 1);
      }
    }).catch((errorInfo) => {
      console.log('Validation failed:', errorInfo);
      // Force form to show validation errors for all fields
      form.validateFields();
    });
  };

  const prev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleOTPVerified = () => {
    setIsOTPVerified(true);
  };

  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return renderStep1();
      case 1:
        return renderStep2();
      case 2:
        return renderStep3();
      case 3:
        return renderStep4();
      default:
        return null;
    }
  };


  const renderStep1 = () => (
    <Step1VehicleInsuranceForm 
      leadViewDetails={leadViewDetails}
      setIsLoading={setIsLoading}
      form={form}
      fileList={fileList}
      setFileList={setFileList}
      fileList1={fileList1}
      setFileList1={setFileList1}
      fileList3={fileList3}
      setFileList3={setFileList3}
      bankerList={bankerList}
      setShowDetailsPage={setShowDetailsPage}
      dateFormat={dateFormat}
    />
  );


  const renderStep2 = () => (
    <Step2FunctionalBrakeEvaluationForm 
      form={form} 
      fileList={fileList} 
      setFileList={setFileList} 
    />
  );

  const renderStep3 = () => (
    <Step3MechanicalExteriorForm 
      fileList={fileList3} 
      setFileList={setFileList3} 
    />
  );

  const renderStep4 = () => (
    <Step4InteriorFinalInspectionForm 
      fileList={fileList4} 
      setFileList={setFileList4}
      leadViewDetails={leadViewDetails}
    />
  );

  return (
    <>
      {showDetailsPage ? (
        // <ExchangeDetailsWithPRocured />
        <Step1DetailsSection />
      ) : showExchangeDetails ? (
        <ExchangeEvaluationDetails leadViewDetails={leadViewDetails} id={id} />
      ) : showLoader ? (
        <>
          <ExchangeStages leadViewDetails={leadViewDetails} />
          <Loader loading={true} />
        </>
      ) : !isOTPVerified ? (
        <>
          <ExchangeStages leadViewDetails={leadViewDetails} />
          <OTPVerification 
            leadViewDetails={leadViewDetails} 
            onOTPVerified={handleOTPVerified} 
            leadId={id}
          />
        </>
      ) : (
        <>
          <Loader loading={isLoading} />
          <div className='user-data lead-detail'>
            {/* Exchange Stages */}
            <ExchangeStages leadViewDetails={leadViewDetails} />
                <div style={{ 
                  backgroundColor: '#ffffff', 
                  borderRadius: '12px',
                  border: '1px solid #e1e5e9',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                  padding: '20px'
                }}>
                  <div style={{ marginBottom: '10px' }}>
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      marginBottom: '12px',
                      gap: '8px'
                    }}>
                      <h6 style={{ margin: 0, color: '#262626', fontWeight: '600', fontSize: '14px' }}>
                        Evaluation Steps
                      </h6>
                      <div style={{
                        marginLeft: 'auto',
                        backgroundColor: '#f0f0f0',
                        padding: '2px 8px',
                        borderRadius: '10px',
                        fontSize: '11px',
                        color: '#666',
                        fontWeight: '500'
                      }}>
                        {currentStep + 1}/{steps.length}
                      </div>
                    </div>
                    
                    <Popconfirm
                      title="Step Not Available"
                      description={`You can only access steps 1 to ${getClickableSteps().maxClickableStep + 1}. Please complete the previous steps first.`}
                      onCancel={handleStepCancel}
                      cancelText="Cancel"
                      open={pendingStep !== null}
                      onOpenChange={(open) => {
                        if (!open) {
                          setPendingStep(null);
                        }
                      }}
                      okButtonProps={{ style: { display: 'none' } }} // 👈 hides OK button
                    >
                      <Steps 
                        current={currentStep} 
                        size="small"
                        onChange={handleStepChange}
                        className="custom-steps"
                      >
                      {steps.map((item, index) => {
                        const { maxClickableStep, isPreEvaluationCompleted } = getClickableSteps();
                        
                        // Determine step status
                        let stepStatus = 'wait';
                        if (index < currentStep) {
                          stepStatus = 'finish';
                        } else if (index === currentStep) {
                          stepStatus = 'process';
                        } else if (index > maxClickableStep && !isPreEvaluationCompleted) {
                          stepStatus = 'wait';
                        }
                        
                        return (
                          <Step 
                            key={item.title} 
                            title={item.title}
                            status={stepStatus}
                            style={{
                              color: stepStatus === 'finish' ? 'rgb(82, 196, 26)' : stepStatus === 'process' ? '#faad14' : '#d9d9d9'
                            }}
                          />
                        );
                      })}
                      </Steps>
                    </Popconfirm>
                  </div>

                  <Form
                    layout='vertical'
                    onFinish={onSubmit}
                    form={form}
                    onValuesChange={(_, values) => calculateTotal(values)}
                    initialValues={{
                      original_invoice_available: 'No',
                      owners_manual_available: 'No',
                      tools_available: 'No',
                      service_history_available: 'No',
                      city_registrations_document: 'No',
                      vin_plate_available: 'No',
                      reregistered_migrated: 'No',
                      one_time_road_tax_paid: 'No',
                     
                      legal_case_present: 'No',
                      accessories_repairs:'No',
                      foreclose_loan:'No'
                    }}
                  >
                    <div style={{marginTop:'40px'}}>
                      {renderStepContent()}
                    </div>

                    <div className='steps-action mt-4' style={{ 
                      display: 'flex', 
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '12px',
                      flexWrap: 'wrap'
                    }}>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-start',
                        flex: '1',
                        minWidth: '120px'
                      }}>
                        {currentStep > 0 && (
                          <Button 
                            style={{ 
                              backgroundColor: '#0a9551', 
                              borderColor: '#0a9551',
                              minWidth: '120px'
                            }}
                            type='primary' 
                            onClick={() => prev()}
                          >
                            Previous
                          </Button>
                        )}
                      </div>
                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'flex-end',
                        flex: '1',
                        flexWrap: 'wrap',
                        gap: '8px'
                      }}>
                        {currentStep < steps.length - 1 && (
                          <Button 
                            type='primary' 
                            onClick={saveAndContinue} 
                            loading={isSaving}
                            style={{ 
                              backgroundColor: '#0a9551', 
                              borderColor: '#0a9551',
                              minWidth: '140px'
                            }}
                          >
                            Save and Continue
                          </Button>
                        )}
                        {currentStep === steps.length - 1 && (
                          <>
                            <Button 
                              type='primary' 
                              ghost 
                              danger 
                              className='primary-button' 
                              onClick={handleCancel}
                              style={{
                                minWidth: '100px'
                              }}
                            >
                              Cancel
                            </Button>
                            {/* <Button type='default' onClick={saveDraft} className='me-3'>
                              Save Draft
                            </Button> */}
                            {/* Show Approve/Reject buttons for Procurement Manager when Pre evaluation is in progress OR Quality Inspection is in progress */}
                            {(roleType === 'Procurement Manager' || roleType === 'Super Admin') && 
                             (leadViewDetails?.exchange_stage_history?.filter(stage => 
                               (stage.lead_exchange_stage_id === 3 && stage.status === 1)
                             ).length > 0) ? (
                              <>
                                <Button 
                                  type='primary' 
                                  danger 
                                  className='primary-button'
                                  onClick={async () => {
                                    try {
                                      await form.validateFields();
                                      const values = form.getFieldsValue();
                                      onSubmit(values, 'reject');
                                    } catch (err) {
                                      // validation errors are displayed by antd; do nothing
                                    }
                                  }}
                                  style={{
                                    minWidth: '100px'
                                  }}
                                >
                                  Reject
                                </Button>
                                <Button 
                                  type='primary' 
                                  className='secondary-button'
                                  onClick={async () => {
                                    try {
                                      await form.validateFields();
                                      const values = form.getFieldsValue();
                                      onSubmit(values, 'approve');
                                    } catch (err) {
                                      // validation errors are displayed by antd; do nothing
                                    }
                                  }}
                                  style={{
                                    minWidth: '100px'
                                  }}
                                >
                                  Approve
                                </Button>
                              </>
                            ) : (
                              <Button 
                                type='primary' 
                                className='secondary-button' 
                                onClick={() => {
                                  form.submit();
                                }}
                                style={{
                                  minWidth: '100px'
                                }}
                              >
                                Submit
                              </Button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                </div>
              
          </div>
        </>
      )}
    </>
  );
};

export default ExchangeEvaluationMultiStep;